
    var riot = require('riot')
    //src: starling/src/tags/node.html
riot.tag2('node',
  '<div ref="container" class=" {this.getRelationshipClassName()} container draggable frontage {this.getStyledCardClasses()} {this.child ? \'child\' : \'top-level\'} level-{this.getDepth()} {this.canvas.getSelectedElementIds().includes(this.id) ? \'selected\' : \'\'} {this.computeExpanded() ? \'expanded\' : \'\'} {this.hasChildren() ? \'container-has-children\' : \'leaf-node\'} {this.instance.getLayoutName()} governing-{this.getGoverningLayoutName()} {this.isInActivePerspective() ? \'tag-selected\' : \'\'} {this.isDragSubject() ? \'drag-subject\' : \'\'} {!this.getIsShownNodeType() || this._getHidden() ? \'hidden\' : \'\'} {this.isCollapsed ? \'collapsed\' : \'\'} {this.isInSearchResults() ? \'search-result\' : \'\'} {this.isMenuOpen() || this.isTitleFocused() ? \'no-fade\' : \'\'} {this.isNodeFocused() ? \'waypoint-focused\' : \'\'} {this.isChildLevelLinkNode() ? \'child-level-r-node\' : \'\'} {this.isTransparent ? \'transparency\' : \'\'} {this.isDraggingSubject ? \'drag-subject no-pointer-events\' : \'\'} {this.isNarrow().self ? \'narrow\' : \'\'} {this.isShownCommentContainer(this.id) ? \'comments-open\' : \'\'} " data-id="{this.instance.id}" onmouseover="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" ondragover="{handleDragOver}" ondrop="{handleFileUpload}" riot-style="{this.getContainerStyle()}"> <div class="screen styled-card_screen styled-card_screen--{this._getDisplayStyle()}" ondragenter="{handleDragEnter}" ondragleave="{handleDragLeave}" ref="screen" data-id="{this.instance.id}" oncontextmenu="{handleRightClick}" ondblclick="{screenDoubleClick}" onclick="{screenClick}"></div> <div id="{`id-${this.id}`}" class="backdrop {getBackdropClass()}" data-created-by-id="{this.createdById}" ref="backdrop"> <div if="{(commentsUI.showComments() && hasComments()) || isShownCommentContainer()}" class="node-comments_button hideWhenPresenting" ondblclick="{ignoreDblClick}" onmouseover="{handleCommentButtonEnter}" onmouseleave="{handleCommentButtonLeave}"> <button class="Button Button--Primary Button--Even Button--Small Button--Plain" onclick="{toggleComments}"> <span if="{this.getTotalCommentCount() > 1}" class="comment_pointer_count comment_pointer_count--node"> {this.getTotalCommentCount()} </span> <svg class="Button__Icon"> <use xlink:href="#mode-comment-icon"></use> </svg> </button> <comments-container node="{instance}" target="node" canvas="{canvas}"></comments-container> </div> <div ref="row" class="row"> <div ref="expandTool" onclick="{toggleExpansion}" ondblclick="{ignoreDblClick}" class="dot expand-tool {this.hasChildren() ? \'has-children\' : \'\'} {expansionToolClass()}" title="{showChildren() ? \'collapse\' : \'expand\'}"> <span if="{this.hasChildren()}" ref="collapsedSearchResultsLabel" class="tooltip tooltip--top search-result-label" style="font-weight: 500;"> 1 collapsed result </span> </div> <div ref="info" class="info {this.hasChildren() ? \'has-children\' : \'\'}"> <div ref="nodeTopLineSizer" class=" node-top-line tip-container top-line-sizer {this.nodeTopLineZoomClass()}-sizer governing-{this.getGoverningLayoutName()} "> <node-eyeball if="{this.enablePerspectiveEyeballTags}" dummy="true"></node-eyeball> <div class="title-wrapper {this.instance.getLayoutName()}"> <div ref="sizerTitle" class="node_title title frontage {this.child ? \'child-title\' : \'top-level-title\'} text-sizer-layer {getTitleLengthClass()}"></div> </div> <node-perspective-dots if="{this.enablePerspectiveDotTags}" dummy="true"></node-perspective-dots> </div> <div ref="nodeTopLine" class=" styled-card_top-line styled-card_top-line--{this._getDisplayStyle()} node-top-line tip-container {this.nodeTopLineZoomClass()} {this.getCurrentTitle() ? \'\' : \'empty-title\'} governing-{this.getGoverningLayoutName()} {this.instance.link() ? \'relationship\' : \'\'} "> <node-eyeball if="{this.enablePerspectiveEyeballTags}"></node-eyeball> <div ref="titleWrapper" class="title-wrapper {summaryBerthClass()}"> <div ref="title" id="node-title-frontage-{this.id}" class="node_title styled-card_title styled-card_title--{this._getDisplayStyle()} shadow-text title frontage {this.child ? \'child-title\' : \'top-level-title\'} rendered-title {getTitleLengthClass()}" data-node-id="{this.id}" onclick="{handleTitleClick}" ondblclick="{ignoreDblClick}" oninput="{handleInput}" onkeydown="{handleTitleKeydown}" onpaste="{handleTitlePaste}" onkeyup="{autocomplete}" onblur="{editTitle}" contenteditable="{this.canvas.isViewOnly() ? \'false\' : \'true\'}" spellcheck="{(!window.config.embedded && window.user && window.user.settings.spellcheck !== 0) ? \'true\' : \'false\'}" placeholder="title"></div> <div ref="highlightTitle" class="node_title title frontage {this.child ? \'child-title\' : \'top-level-title\'} text-highlight-layer"></div> </div> <node-perspective-dots if="{this.enablePerspectiveDotTags}"></node-perspective-dots> </div> <div ref="summaryWrapper" class="summary-wrapper {summaryBerthClass()}"> <div ref="summary" data-empty-view-only="{this.canvas.isViewOnly() && (!this.getCurrentSummary() || !this.getCurrentSummary().length) ? \'true\' : \'false\'}" class="summary shadow-text node_summary {this.child ? \'child-summary\' : \'top-level-summary\'} rendered-summary styled-card_summary styled-card_summary--{this._getDisplayStyle()} {getTitleLengthClass()}" data-node-id="{this.id}" onclick="{handleSummaryClick}" ondblclick="{ignoreDblClick}" onpaste="{handleSummaryPaste}" oninput="{handleInput}" onblur="{editSummary}" onkeydown="{checkBlurKey}" contenteditable="{this.canvas.isViewOnly() ? \'false\' : \'true\'}" spellcheck="{(!window.config.embedded && window.user && window.user.settings.spellcheck !== 0) ? \'true\' : \'false\'}" placeholder="summary"></div> <div ref="highlightSummary" class="summary {this.child ? \'child-summary\' : \'top-level-summary\'} text-highlight-layer"></div> </div> <node-perspective-annotations if="{this.enablePerspectiveDotTags}"></node-perspective-annotations> </div> <div ref="menuTool" class="menu-tool"></div> </div> <site-previewer ref="sitePreviewer" if="{getTitleAndSummaryLinks() && getTitleAndSummaryLinks().length}" canvas="{canvas}" sites="{getTitleAndSummaryLinks()}"></site-previewer> <node-attributes displaystyle="{this._getDisplayStyle()}" if="{this.instance.attributes[\'card\'] && this.instance.attributes[\'card\'].length}"></node-attributes> <div if="{showImage()}" ref="imageWrapper" class="image-wrapper {this.instance.getLayoutName()}" riot-style="{getImageWrapperStyle()}"> <div class="image-container" onmouseenter="{handleImageMouseEnter}" onmouseleave="{handleImageMouseLeave}" oncontextmenu="{handleImageRightClick}"> <img ref="image" class="node-image" riot-src="{getImageSrc()}" riot-style="{getImageStyle()}"> <div if="{!canvas.isViewOnly()}" class="resize-handle image-resize-handle" ref="imageResizeHandle"></div> <button if="{!this.canvas.isViewOnly()}" ref="imageMenuToggle" class="floating-menu_button image-overlay-menu-button" onclick="{toggleImageMenu.bind(this, \'image\')}"> <i class="material-icons floating-menu_button_icon">more_vert</i> </button> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> </div> </div> <div if="{showVideo()}" ref="videoWrapper" class="image-wrapper {this.instance.getLayoutName()}" riot-style="{getImageWrapperStyle()}"> <div ondblclick="{this.ignoreDblClick}" class="image-container" oncontextmenu="{handleVideoRightClick}" onclick="{handleVideoClick}" riot-style="{getVideoStyle()}"> <video ref="video" class="node-image" riot-src="{getImageSrc()}" preload="metadata" riot-style="{getVideoStyle()} transform: translateZ(0);"> </video> <i class="material-icons play-button" style="pointer-events: none;">play_circle_outline</i> <button if="{!this.canvas.isViewOnly()}" ref="imageMenuToggle" class="floating-menu_button image-overlay-menu-button" onclick="{toggleImageMenu.bind(this, \'video\')}"> <i class="material-icons floating-menu_button_icon">more_vert</i> </button> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> </div> </div> <div class="files-container" if="{this.showFile()}" ondblclick="{this.ignoreDblClick}" oncontextmenu="{this.handleFileRightClick}" onclick="{this.handleFileRightClick}"> <a href="{this.getFileUrl()}" data-extension="{this.getFileExtension()}" target="_blank" class="file-bar"> <svg class="file-icon" riot-style="color: {this.getFileIconColor(this.getIconName())}"> <use xlink:href="#{this.getIconName()}"></use> </svg> <span class="file-name">{this.getFileName()}</span> </a> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> </div> <div if="{!canvas.isViewOnly()}" class="resize-handle {!canvas.isViewOnly() && this.instance.getLayoutName() !== \'layout-freehand\' ? \'ready\' : \'\'} " ref="nodeResizeHandle"></div> <div ref="colGroupContainer" class="col-group-container {showImage() ? \'with-image\' : \'\'} {this.hasChildren() ? \'has-children\' : \'\'}"> <child-nodes if="{this.hasChildren() || this.getLayoutName() === \'layout-freehand\'}" canvas="{canvas}" class="styled-card_child-nodes styled-card_child-nodes--{this._getDisplayStyle()}"></child-nodes> <div class="empty-child-nodes" if="{!this.hasChildren() > 0}"></div> <div ref="partBarTool" class="part-anchor {this.hasChildren() > 0 ? \'has-children\' : \'childfree\'} {this.instance.getLayoutName()} {this.showChildren() ? \'\' : \'collapsed\'}" hide="{this.canvas.isViewOnly()}"> </div> </div> </div>',
  '',
  'ref="main" oncontextmenu="{stopRightClickPropagation}"', function(opts) {
'use strict';

var _this = this;

var _richText = require('lib/rich-text');

var _richText2 = _interopRequireDefault(_richText);

var _constants = require('lib/constants');

var _uuid = require('../../../shared/lib/uuid');

var _sharedUtil = require('lib/shared-util');

var _files = require('lib/files.js');

var _util = require('lib/util');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _searchUi = require('lib/search-ui');

var _appUi = require('lib/app-ui');

var _fileAttachmentsUi = require('lib/file-attachments-ui');

var _zoomUi = require('lib/zoom-ui');

var _sitePreviewUi = require('lib/site-preview-ui');

var _linksUi = require('lib/links-ui');

var _text = require('lib/text');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _perspectivesUi = require('lib/perspectives-ui');

var _nodesUi = require('lib/nodes-ui');

var _custom_errors = require('../../../lib/custom_errors');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

var _upsellUi = require('lib/upsell-ui');

var _nodeDragHandlers = require('lib/node-drag-handlers');

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _resizeObserverPolyfill = require('resize-observer-polyfill');

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _collaboratorsUi = require('lib/collaborators-ui');

var _commentsUi = require('lib/comments-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var self = this;

this.instance = this.opts.instance;
this.id = this.instance.id;
this.title = this.opts.title;
this.summary = this.opts.summary;
this.x = parseFloat(opts.x);
this.y = parseFloat(opts.y);
this.canvas = this.parent.opts.canvas;
this.operation = this.canvas.operation;
this.child = this.opts.child;
this.isLinkNode = this.instance.link();
this.height = this.instance.height;
this.isNode = true;
this.expanded = null;
this.alternateTitlesExpanded = false;
this.activePointPerspective = null;
this._hasChildren = this.instance.children().length;

var _canvas = this.canvas,
    config = _canvas.config,
    access = _canvas.access;

this.hasChildren = function () {
  return _this._hasChildren;
};

this.setIsNarrow = function () {
  _this._isNarrow = _this.isNarrow();
  _this.refs.container.classList.toggle('narrow', _this._isNarrow.self);
};

this.getIsNarrow = function () {
  // seems like this should be cacheable but it's tricky...
  return _this.isNarrow();
};

this.isNarrow = function () {

  var narrowSelf = true;
  var narrowChildren = true;

  var threshold = 270;

  function _testNarrow(n, isChild) {

    var nodeTag = canvas.nodeTags[n.id];
    if (!nodeTag) return;

    var titleEl = nodeTag.refs.title;
    var summaryEl = nodeTag.refs.summary;

    if (!titleEl || !summaryEl) return;

    var titleExceedsThres = (0, _text.textExceedsThreshold)(titleEl, n.title, threshold);
    var summaryExceedsThres = (0, _text.textExceedsThreshold)(summaryEl, n.summary, threshold);

    if (titleExceedsThres || summaryExceedsThres) {
      if (!isChild) narrowSelf = false;
      if (isChild) narrowChildren = false;
    }

    // stop traversing if children are detached
    if (!n.getChildrenDetached()) return;

    // stop tranversing if we already have our answer
    if (!narrowChildren) return;

    for (var _iterator = n.children(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var child = _ref;

      _testNarrow(child, true);
    }
  }

  _testNarrow(_this.instance);

  return { self: narrowSelf, children: narrowChildren };
};

this.on('update', function () {
  _this._hasChildren = _this.instance.children().length;
});

this.on('mount', function () {
  _this.computeExpanded();
  _this.updateTitleDisplay();
  _this.updateSummaryDisplay();
  // two underscores cancel each other out
  _this.instance = opts.instance.__.item;

  var resizeObserver = new _resizeObserverPolyfill2.default(function (entries) {
    /*
      don't trigger resize observer after zooming
    */
    if (_zoomUi.zoomUI.recentlyZoomed) return;

    for (var _iterator2 = entries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var entry = _ref2;

      if (entry.target == _this.refs.container && !_this.instance.parentId) {
        _this.instance.width = entry.contentRect.width;
        _this.instance.height = entry.contentRect.height;
        var paddingThreshold = 600;
        if (!_this.instance.parentId) {
          if (_this.instance.width > paddingThreshold && !_this._wide) {
            _this._wide = true;
            _this.refs.backdrop.classList.add('large-padding');
          } else if (_this.instance.width <= paddingThreshold && _this._wide) {
            _this._wide = false;
            _this.refs.backdrop.classList.remove('large-padding');
          }
          _this.reclipLinks();
        }
      }
    }
  });

  resizeObserver.observe(_this.refs.container);

  // clean up the node in the store
  var node = _store_instance2.default.getNode(self.id);
  if (node) {
    node.clean();
  }
});

// set a class if this card is fully previewable at high zoom levels through the magnified view or if it is too large
this.setPreviewable = function () {
  var node = _store_instance2.default.getNode(_this.id);
  $('.previewable').removeClass('.previewable');
  if (node.getParent() && node.getLayoutName() !== 'layout-freehand' && node.width <= window.innerWidth / 2 && node.height <= window.innerHeight / 2) {
    _this.refs.container.classList.add('previewable');
  } else {
    _this.refs.row.classList.add('previewable');
  }
};
this.unsetPreviewable = function () {
  _this.refs.container.classList.remove('previewable');
  _this.refs.row.classList.remove('previewable');
};

this._getDisplayStyle = function () {
  return _this.instance.getDisplayStyle() || 'standard';
};

this.handleCommentButtonEnter = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  _this.canvas.nodeTools.hide();
  _this.onCommentButton = true;
};

this.handleCommentButtonLeave = function (e) {
  _this.onCommentButton = false;
};

this.handleMouseEnter = function (e) {
  e.stopPropagation();

  if (e.target && $(e.target).closest('child-nodes') && $(e.target).closest('child-nodes', _this.root).hasClass('detached')) {
    // hover over popout
    return;
  }

  if (_this.canvas.linkDragging) {
    _this.canvas.setMouseEnteredNode(_this);
    return;
  }
  if (_this.canvas.nodeMenuTag.summoned) return;
  if (_this.canvas.dragging) return;
  if (_this.canvas.rightClickMenuIsOpen()) return;

  var myLinks = _this.instance.links();

  for (var _iterator3 = myLinks, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var link = _ref3;

    var svg = _this.canvas.linkTags[link.id] && _this.canvas.linkTags[link.id].refs && _this.canvas.linkTags[link.id].refs.svg;
    svg && svg.classList.add('hovered-node');
    _this.canvas.linkTags[link.id].removeClipPolygon();
  }

  if (_this.getLayoutName() == 'layout-freehand' && !_this.canvas.selecting && _this.childNodesTag) {
    _this.canvas.selectionArea.setupDragging(_this.childNodesTag.refs.childNodes);
  }
  _this.canvas.setMouseEnteredNode(_this);
  if (!_this.canvas.rightClickMenu.summoned) {
    if (_this.canvas.nodeToolsSummonTimeout) clearTimeout(_this.canvas.nodeToolsSummonTimeout);
    if (_this.canvas.nodeTools.nodeId !== _this.id) {
      _this.canvas.nodeTools.hide();
    }
    _this.canvas.nodeToolsSummonTimeout = setTimeout(function () {
      if (_this.onCommentButton) return;

      _this.canvas.nodeTools.summon({
        node: _this,
        summonedFromChildNodes: false,
        positionReferenceElement: _this.refs.container
      });
    }, _constants.NODE_TOOLS_SUMMON_DELAY);
  }
};

this.summaryBerthClass = function () {
  var summary = _this.instance.summary;
  if (summary && (summary.trim().includes("\n") || summary.length > 210)) {
    return 'berth-eligible';
  }
};

this.fadeOut = function (opts) {
  if (_this.instance.getParent()) {
    _this.topLevelParentTag().fadeOut({ parent: true });
  }
  var className = 'waypoint-focused';
  if (opts && opts.parent) {
    className = 'parent-of-waypoint-focused';
  }
  if (_this.refs.container && _this.refs.container.classList.contains(className)) {
    _this.refs.container.classList.remove(className);
  }
};

this.fadeIn = function (opts) {
  if (_this.instance.getParent()) {
    _this.topLevelParentTag().fadeIn({ parent: true });
  }
  var className = 'waypoint-focused';
  if (opts && opts.parent) {
    className = 'parent-of-waypoint-focused';
  }
  if (_this.refs.container && !_this.refs.container.classList.contains(className)) {
    _this.refs.container.classList.add(className);
  }
};

this.isNodeFocused = function () {
  return _presentationUi2.default.isNodeFocused(_this.id);
};

this.refreshWaypointFade = function () {
  if (_presentationUi2.default.isNodeFocused(_this.id)) {
    _this.fadeIn();
  } else {
    _this.fadeOut();
  }
};

this.removeHoveredState = function () {
  var myLinks = _this.instance.links();

  for (var _iterator4 = myLinks, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray4) {
      if (_i4 >= _iterator4.length) break;
      _ref4 = _iterator4[_i4++];
    } else {
      _i4 = _iterator4.next();
      if (_i4.done) break;
      _ref4 = _i4.value;
    }

    var link = _ref4;

    var svg = _this.canvas.linkTags[link.id] && _this.canvas.linkTags[link.id].refs && _this.canvas.linkTags[link.id].refs.svg;
    svg && svg.classList.remove('hovered-node');
    _this.canvas.linkTags[link.id].setClipPolygon();
  }

  _this.canvas.clearMouseEnteredNode();
};

this.handleMouseLeave = function (e) {
  if (_this.canvas.nodeMenuTag.summoned) return;
  if (_this.canvas.dragging) return;
  if (_this.canvas.rightClickMenu.summoned) return;
  if (_this.canvas.nodeToolsSummonTimeout) clearTimeout(_this.canvas.nodeToolsSummonTimeout);
  /* safari doesn't handle dragLeave well, so use this opportunity to clear out any file hover states */
  _this.removeHoveredState();
  _this.canvas.setDragEnteredNode(null);
  _this.canvas.resizingNode = false;
  var ancestor = $(e.relatedTarget).closest('node .container, .detached > .child-nodes-container')[0];

  var ancestorId = void 0,
      ancestorTag = void 0;
  if (_this.getLayoutName() == 'layout-freehand' && !_this.canvas.selecting) {
    _this.canvas.selectionArea.resetSelectionAreaTarget();
  }
  if (ancestor) {
    ancestorId = ancestor.getAttribute('data-id');
    if (ancestor.classList.contains('child-nodes-container')) {
      ancestorTag = _this.canvas.childNodeTags[ancestorId];
      _this.canvas.nodeToolsSummonTimeout = setTimeout(function () {
        if (!_this.canvas.linkDragging) {
          _this.canvas.nodeTools.summon({
            node: ancestorTag,
            summonedFromChildNodes: true,
            hideRelationshipTool: true,
            hidePerspectiveTool: true,
            positionReferenceElement: ancestorTag.refs.container
          });
        }
      }, _constants.NODE_TOOLS_SUMMON_DELAY);
    } else {
      ancestorTag = _this.canvas.nodeTags[ancestorId];
    }
    _this.canvas.setMouseEnteredNode(ancestorTag);
  } else {
    if (!_this.expanded) {
      if (!_this.canvas.nodeMenuTag.summoned) {
        _this.canvas.nodeTools.hide();
      }
    }
  }
  if (_this.refs && _this.refs.backdrop) {
    _this.refs.backdrop.style.removeProperty('box-shadow');
  }
};

this.getDepth = function () {
  return _this.instance.ancestors().length;
};

this.getParent = function () {
  return _this.instance.getParent();
};

this.topLevelParentTag = function () {
  var topParent = _this.instance.getTopLevelParent();
  if (topParent) {
    return _this.canvas.nodeTags[topParent.id];
  }
  return _this;
};

this.topNonFreehandParentTag = function () {
  var topParent = _this.instance.getTopNonFreehandParent();
  if (topParent) {
    return _this.canvas.nodeTags[topParent.id];
  }
  return _this;
};

this.parentTag = function () {
  var parent = _this.getParent();
  if (parent) {
    return _this.canvas.nodeTags[parent.id];
  }
};

this.linkTag = function () {
  var link = _this.instance.link();
  if (link) {
    return _this.canvas.linkTags[link.id];
  }
};

this.isInSearchResults = function () {
  return _searchUi.searchUI.isInSearchResults(_this.id);
};

this.isInActivePerspective = function () {
  var perspectives = _perspectivesUi.pui.getActivePerspectives();
  if (perspectives.some(function (p) {
    return p.hasMemberNode(_this.id);
  })) {
    return true;
  }
  return false;
};

this.isMenuOpen = function () {
  if (_this.canvas.nodeMenuTag && _this.canvas.nodeMenuTag.node && _this.canvas.nodeMenuTag.node.id === _this.id) {
    return true;
  }
  if (_this.canvas.rightClickMenu.isSummonedToNode(_this.id)) {
    return true;
  }
  return false;
};

this.focusNextSibling = function (e) {
  if (!_this.instance.parentId) {
    return;
  }
  if (_this.getGoverningLayoutName() == 'layout-freehand') {
    return;
  }
  if (_this.focusNextPartSibling(e)) {
    return;
  }
};

this.focusPrevSibling = function (e) {
  if (!_this.instance.parentId) {
    return;
  }
  if (_this.getGoverningLayoutName() == 'layout-freehand') {
    return;
  }
  if (_this.focusPrevPartSibling(e)) {
    return;
  }
};

this.focusPrevPartSibling = function (e) {
  var prevSibling = _this.instance.getPrevSibling();
  if (prevSibling) {
    var prevNode = _this.canvas.nodeTags[prevSibling.id];
    _this.canvas.setSelectedElement(prevNode);
    e.preventDefault();
    prevNode.focusTitle();
  }
  return prevSibling;
};

this.focusNextPartSibling = function (e) {
  var nextSibling = _this.instance.getNextSibling();
  if (nextSibling) {
    var nextNode = _this.canvas.nodeTags[nextSibling.id];
    _this.canvas.setSelectedElement(nextNode);
    e && e.preventDefault();
    nextNode.focusTitle();
  }
  return nextSibling;
};

this.focusOrCreateNextSibling = function () {
  // do nothing if we're a top level node
  if (!_this.instance.parentId) {
    return;
  }
  if (_this.getGoverningLayoutName() == 'layout-freehand') {
    return;
  }
  if (_this.focusNextPartSibling()) {
    return;
  }

  // create new sibling
  _this.canvas.lastNodeCreatedWithEnterKey = _this.parentTag().addPart();
};

this.autocomplete = function (e) {
  var TAB = _constants.KEY_CODES.TAB,
      ENTER = _constants.KEY_CODES.ENTER,
      DELETE = _constants.KEY_CODES.DELETE,
      BACKSPACE = _constants.KEY_CODES.BACKSPACE;

  if (e.shiftKey && e.keyCode == ENTER) {
    _this.canvas.autocompleteTag.hide();
    return;
  }
  if (e.keyCode == TAB) {
    return;
  }
  if (!e.keyCode) {
    return;
  }
  if (e.keyCode === DELETE || e.keyCode === BACKSPACE) {
    e.stopPropagation();
  }
  var query = _this.refs.title.innerText;
  if (!query.trim()) {
    return;
  }
  _this.canvas.autocompleteTag.getResults(query);
  var autocompleteTop = 0;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var titleElement = document.getElementById('node-title-frontage-' + _this.id);

  if (titleElement) {
    autocompleteTop = titleElement.getBoundingClientRect().bottom;
  }

  _this.canvas.autocompleteTag.updatePosition({
    x: _this.absolutePosition.x - 7,
    y: (autocompleteTop - ty) / scale
  });
};

this.isChildLevelLinkNode = function () {
  var link = _this.instance.link();
  return link && (link.fromNode().parentId || link.toNode().parentId);
};

this.resizeParent = function (extraSpace) {
  var parentTag = self.parentTag();
  if (parentTag) {
    parentTag.childNodesTag.fitToContents({ extraSpace: extraSpace });
    _this.canvas.nodeTags[parentTag.id].childNodesTag.fitToContents({ extraSpace: extraSpace });
  }
};

this.highlight = function () {
  _this.refs.container.classList.add("highlighted");
};

this.unHighlight = function () {
  _this.refs.container.classList.remove("highlighted");
};

this.setLocalBorderHighlightColor = function (color) {
  if (_this.refs.container) {
    _this.refs.container.style.setProperty('--card-border-highlight-color', color);
  }
};

this.unsetLocalBorderHighlightColor = function (color) {
  if (_this.refs.container) {
    _this.refs.container.style.removeProperty('--card-border-highlight-color');
  }
};

this.setPresenceHovered = function () {
  var container = _this.refs.container;

  if (container) {
    container.classList.add("user-presence-highlight");
  }

  if (_this.refs.container && !_this.refs.container.classList.contains('user-presence-highlight')) {
    _this.refs.container.classList.add('user-presence-highlight');
  }
  var parent = self.topLevelParentTag();
  if (parent && parent.id !== _this.id && parent && parent.refs && parent.refs.container && !parent.refs.container.classList.contains('parent-of-user-presence-highlight')) {
    parent.refs.container.classList.add('parent-of-user-presence-highlight');
  }
};

this.unsetPresenceHovered = function () {
  _this.perspectiveHighlighted = false;
  if (_this.refs.container) {
    _this.refs.container.classList.remove('user-presence-highlight');
  }
  var parent = self.topLevelParentTag();
  if (parent && parent.refs && parent.refs.container && !parent.refs.container.querySelector('.user-presence-highlight')) {
    parent.refs.container.classList.remove('parent-of-user-presence-highlight');
  }
};

// highlight the field that didn't save and attach an error tooltip
this.flagErrorField = function (field) {
  var element = void 0;
  if (field == 'title') {
    element = _this.refs.title;
  } else if (field == 'summary') {
    element = _this.refs.summary;
  }
  if (element) {
    element.classList.add('error');
  }
  self.refs.container.classList.add('error');
  self.refs.container.setAttribute('data-tip-align', 'top');
  self.refs.container.setAttribute('data-tip', 'Changes failed to save');
};

this.handleInput = function (_ref5) {
  var target = _ref5.target;

  var is = function is(className) {
    return target.classList.contains(className);
  };
  var companionKey = is('title') ? 'title' : is('summary') ? 'summary' : '';

  if (companionKey === 'title') {
    _this.titleInputText = _this.refs.title.innerText;
    if (_this.refs.title.innerText.length) {
      self.refs.nodeTopLine.classList.remove('empty-title');
    } else {
      self.refs.nodeTopLine.classList.add('empty-title');
    }
  }

  // if search modal is open, update search results as you type
  _searchUi.searchUI.unsetFocusedResult();
  _searchUi.searchUI.refreshResults();

  _this.resizeParent(false);

  _this.updateLayers();
  _this.cleanupContent(companionKey);
  _this.rediscoverLinkPositions();
};

this.handleTitleKeydown = function (e) {
  var DELETE = _constants.KEY_CODES.DELETE,
      BACKSPACE = _constants.KEY_CODES.BACKSPACE,
      LEFT_ARROW = _constants.KEY_CODES.LEFT_ARROW,
      RIGHT_ARROW = _constants.KEY_CODES.RIGHT_ARROW,
      KEY_C = _constants.KEY_CODES.KEY_C,
      KEY_X = _constants.KEY_CODES.KEY_X;

  e.stopPropagation();

  if (_this.canvas.isViewOnly() && !(e.keyCode == KEY_C && (e.ctrlKey || e.metaKey))) {
    e.preventDefault();
    // allow text to be copied in view only mode & when there's a stop-the-world error
    return;
  }
  _this.checkBlurKey(e);
};

this.handleTitlePaste = function (e) {
  e.preventDefault();
  if (_this.canvas.isViewOnly()) return;
  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData("text/plain")));
  document.execCommand("insertHTML", false, text);
  _searchUi.searchUI.refreshResults();
};

this.handleSummaryPaste = function (e) {
  e.preventDefault();
  if (_this.canvas.isViewOnly()) return;
  var target = e.target;

  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData("text/plain")));
  _searchUi.searchUI.refreshResults();
  document.execCommand("insertHTML", false, text);
};

this.getTitleAndSummaryLinks = function () {
  var node = _this.canvas.store.getNode(_this.id);

  var hiddenTitleHrefs = node.getTitle().meta.filter(function (meta) {
    return meta[0] === 'a';
  }).map(function (meta) {
    return meta[3][0][1];
  });

  var hiddenSummaryHrefs = node.getSummary().meta.filter(function (meta) {
    return meta[0] === 'a';
  }).map(function (meta) {
    return meta[3][0][1];
  });

  var manualLinks = (0, _sharedUtil.getPlecticaLinksFromUrls)({
    urls: hiddenTitleHrefs.concat(hiddenSummaryHrefs),
    config: window.config
  });

  var autoLinks = (0, _sharedUtil.getPlecticaLinksFromString)({
    string: node.getTitle() + ' ' + node.getSummary(),
    config: window.config
  });

  var result = Array.from(new Set(manualLinks.concat(autoLinks)));
  return result;
};

this.updateTitleDisplay = function () {
  var titleEl = _this.refs && _this.refs.title;
  if (!titleEl) return;

  var node = _this.canvas.store.getNode(_this.id);
  var titleHTML = _this.getCurrentTitle(true);

  if (titleEl.innerHTML !== titleHTML) {
    titleEl.innerHTML = titleHTML;
    _this.refs.sizerTitle.innerHTML = titleHTML;
  }
};

this.updateSummaryDisplay = function () {

  var summaryEl = _this.refs && _this.refs.summary;
  if (!summaryEl) return;

  var node = _this.canvas.store.getNode(_this.id);
  var summaryHTML = _this.getCurrentSummary(true);

  if (summaryEl.innerHTML !== summaryHTML) {
    summaryEl.innerHTML = summaryHTML;
  }
};

this.checkBlurKey = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      TAB = _constants.KEY_CODES.TAB,
      ESCAPE = _constants.KEY_CODES.ESCAPE,
      UP_ARROW = _constants.KEY_CODES.UP_ARROW,
      DOWN_ARROW = _constants.KEY_CODES.DOWN_ARROW,
      CTRL_Z = _constants.KEY_CODES.CTRL_Z;

  e.stopPropagation();

  if (e.keyCode == TAB && e.shiftKey) {
    window.getSelection().empty();
    _this.canvas.hidePopups();
    _this.focusPrevSibling(e);
  } else if (e.keyCode == TAB) {
    window.getSelection().empty();
    _this.canvas.hidePopups();
    _this.focusNextSibling(e);
  } else if ((e.ctrlKey || e.metaKey) && e.which == CTRL_Z) {
    if (self.refs.title.innerText.length === 0) {
      e.preventDefault();
      _this.editTitle(e);
      _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return self.operation.undo();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
      _this.canvas.hidePopups();
    }
  } else if (e.keyCode == ENTER && (e.ctrlKey || e.metaKey)) {
    e.preventDefault();
    _this.canvas.lastNodeCreatedWithEnterKey = _this.addPart();
  } else if (e.keyCode == ENTER && !e.shiftKey && e.target !== _this.refs.summary) {
    e.preventDefault();
    window.getSelection().empty();
    e.target.blur();
    _this.focusOrCreateNextSibling();
  } else if (e.keyCode == ESCAPE) {
    e.preventDefault();
    e.stopPropagation();
    window.getSelection().empty();
    _this.revertTitle(e);
    _this.canvas.hidePopups();
  } else if (e.keyCode == DOWN_ARROW) {
    if (_this.canvas.autocompleteTag.isShowing()) {
      _this.canvas.autocompleteTag.incrementSelected(1);
      e.stopPropagation();
      e.preventDefault();
    }
  } else if (e.keyCode == UP_ARROW) {
    if (_this.canvas.autocompleteTag.isShowing()) {
      _this.canvas.autocompleteTag.incrementSelected(-1);
      e.stopPropagation();
      e.preventDefault();
    }
  }
  _searchUi.searchUI.refreshResults();
};

this.getHeight = function () {
  return _this.instance.getHeight();
};

this.getContainerStyle = function () {

  var styles = 'top: 0; left: 0;';

  if ((!_this.child || _this.parentId && _this.getParent() && _this.getParent().getLayoutName() == 'layout-freehand') && (_this.instance.y || _this.instance.x)) {
    var link = _this.instance.link();
    if (link && link.lineCurvature === 'elbow') {

      var fromPoint = link.fromNode().getFirstVisibleAncestorPosition();
      var toPoint = link.toNode().getFirstVisibleAncestorPosition();

      styles = 'top: ' + (_this.instance.y || 0) + 'px; left: ' + (_this.instance.x || 0) + 'px; transform: translate(-50%, -17px);';
    } else {

      styles = 'top: ' + (_this.instance.y || 0) + 'px; left: ' + (_this.instance.x || 0) + 'px;';
    }
  }

  var color = _this.instance.getBackgroundColor();

  styles += (0, _util.getStyleColorVariables)({
    color: color,
    style: _this._getDisplayStyle()
  });

  if (_this.instance.getLayoutName() !== 'layout-freehand' && _this.instance.getGoverningLayoutName() !== 'layout-row') {
    styles += '\n          min-width: ' + _this.instance.userWidth + 'px;\n        ';
  }
  if (!_this.instance.getIsCollapsed() && _this.instance.getLayoutName() !== 'layout-freehand') {
    styles += 'min-height: ' + _this.instance.userHeight + 'px;';
  }

  return styles;
};

this.updateContainerStyle = function () {
  _this.refs.container.style = _this.getContainerStyle();
};

this.showChildren = function () {
  return !_this.instance.getIsCollapsed();
};

this.updateDescendants = function () {
  _this.update({ forceUpdate: true });
  function descend(node) {
    for (var _iterator5 = node.children(), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref7;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref7 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref7 = _i5.value;
      }

      var n = _ref7;

      var nt = self.canvas.nodeTags[n.id];
      nt.update({ forceUpdate: true });
      descend(n);
    }
  }
  descend(_this.instance);
};

this.expansionToolClass = function () {
  if (!_this.hasChildren()) {
    return '';
  }
  var isCollapsed = self.instance.getIsCollapsed();

  if (isCollapsed) {
    return 'fa fa-angle-up node-collapsed';
  } else {
    return 'fa fa-angle-down node-expanded';
  }
};

this.getBackdropClass = function () {
  var justification = _this.instance.justification || 'left';
  return 'justify-' + justification;
};

/* get results off of store to avoid oddities with instance and instance's cache */
this.getIsShownNodeType = function () {
  var node = _this.canvas.store.getNode(_this.id);
  if (node) {
    return node.isShownNodeType();
  } else {
    return false;
  }
};
/* must be unique function from store node.getHidden() */
this._getHidden = function () {
  var node = _this.canvas.store.getNode(_this.id);
  return node.hidden;
};

this.expand = function () {
  var instance = _this.instance;

  instance.setIsCollapsed(false);
  instance.setDescendantsHidden(false);
  _this.canvas.store.clearNodeCaches();
  _this.updateTopLevelNeighborsLite();
  _this.discoverPosition();
  _this.topLevelParentTag().rediscoverLinkPositions();
};

this.collapse = function () {
  var instance = _this.instance;

  instance.setIsCollapsed(true);
  instance.setDescendantsHidden(true);
  _this.canvas.store.clearNodeCaches();
  _this.updateTopLevelNeighborsLite();
  _this.discoverPosition();
  _this.topLevelParentTag().rediscoverLinkPositions();
};

this.toggleExpansion = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (!_this.hasChildren()) return;

  if (self.instance.getIsCollapsed()) {
    _this.expand();
  } else {
    _this.collapse();
  }

  // allow expand/collapse but don't propagate to other users or save state
  _searchUi.searchUI.refreshResults();

  var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({
    nodeTag: _this,
    fromExpand: !self.instance.getIsCollapsed(),
    fromCollapse: self.instance.getIsCollapsed(),
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps.prevNodePositions,
      nodePositions = _nui$fixOverlaps.nodePositions;

  if (_this.canvas.isViewOnly()) {
    return;
  }

  var messages = [];

  if (nodePositions.length) {
    messages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  messages.push(self.operation.messages.setCollapsedState({
    nodeUUID: self.id,
    isCollapsed: self.instance.getIsCollapsed()
  }));

  self.operation.batchOperation({
    messages: messages,
    onFailure: function onFailure(err) {
      console.log('batchOperation failure: ' + err);
    }
  });
  _this.updateContainerStyle();
};

this.reclipLinks = function () {
  var _instance$absolutePos = _this.instance.absolutePosition,
      x = _instance$absolutePos.x,
      y = _instance$absolutePos.y;
  var _instance = _this.instance,
      width = _instance.width,
      height = _instance.height;

  var rect = {
    left: x,
    top: y,
    right: x + width,
    bottom: y + height,
    width: width,
    height: height
  };

  var unscaledRect = (0, _util.unscaleRect)({ rect: rect, canvas: canvas });
  _nodesUi.nui.reclipLink(unscaledRect, _this);
};

this.updateNeighborsLite = function () {
  self.updateNodesDisplayRecursively();
};

this.updateTopLevelNeighborsLite = function () {
  var node = _store_instance2.default.getNode(_this.id);
  if (!node) {
    return;
  }
  if (node.parentId) {
    self.topLevelParentTag().updateNeighborsLite();
  } else {
    self.updateNeighborsLite();
  }
};

// update the hidden state of all descendants of this node
// (no calls to riotjs update() functions)

this.updatePopoutShadows = function (id) {
  var nodeTag = self.canvas.nodeTags[id];
  if (nodeTag && nodeTag.childNodesTag) {
    nodeTag.childNodesTag.updateShadow();
    if (nodeTag.instance.link()) {
      var linkTag = _this.canvas.linkTags[nodeTag.instance.link().id].updatePosition();
    }
  }
};

this.updateChildDetachment = function (id) {
  var nodeTag = self.canvas.nodeTags[id];
  if (nodeTag && nodeTag.childNodesTag) {
    nodeTag.childNodesTag.updateDetachment();
  }
};

// recursively refresh display properties of nodes, following each link / link node
// (this avoids calling any riotjs update() function)
this.updateNodesDisplayRecursively = function (opts) {

  var affectedNodeIds = [];
  var seen = {};
  var updateNodes = function updateNodes(startingNode) {
    if (!startingNode || !startingNode.id) {
      return;
    }
    if (!seen[startingNode.id]) {
      seen[startingNode.id] = 1;
      affectedNodeIds.push(startingNode.id);
    }
    (0, _util.updateDisplayProperties)(startingNode.id, _this.canvas);

    for (var _iterator6 = startingNode.links(), _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray6) {
        if (_i6 >= _iterator6.length) break;
        _ref8 = _iterator6[_i6++];
      } else {
        _i6 = _iterator6.next();
        if (_i6.done) break;
        _ref8 = _i6.value;
      }

      var link = _ref8;

      var linkTag = self.canvas.linkTags[link.id];
      if (linkTag) {
        linkTag.updateHiddenState();
        linkTag.updatePosition();
        linkTag.updateCollapsedState();
      }

      if (link.linkNodeId && link.linkNode()) {
        link.placeLinkNode();
        updateNodes(link.linkNode());
      }
    }
    var nodeTag = _this.canvas.nodeTags[startingNode.id];
    // go through child nodes in the order in which they are rendered on the canvas
    for (var _iterator7 = startingNode.children(), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref9;

      if (_isArray7) {
        if (_i7 >= _iterator7.length) break;
        _ref9 = _iterator7[_i7++];
      } else {
        _i7 = _iterator7.next();
        if (_i7.done) break;
        _ref9 = _i7.value;
      }

      var child = _ref9;

      updateNodes(child);
    }
    if (!opts || !opts.ignoreRefreshFreehandAncestors) {
      (0, _util.refreshFreehandAncestorsOfList)([startingNode.id], _this.canvas, _store_instance2.default);
    }
    _this.updatePopoutShadows(startingNode.id);
  };

  updateNodes(_store_instance2.default.getNode(_this.id));
  _this.canvas.tags['link-handles'].position();
};

// refresh the sizing of nested freehand containers so that the parent takes into account the child's size
this.refreshFreehandAncestors = function () {
  _this.discoverPosition();
  _this.updateNodesDisplayRecursively([_this.id]);
};

this.handleAddPart = function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  // disable double click in list view on child nodes that are not detached
  if (_this.parentId && _this.getLayoutName() != 'layout-freehand' && !_this.getChildrenDetached()) {
    return;
  }
  _this.canvas.lastNodeCreatedWithEnterKey = null;
  _this.addPart(e.clientX, e.clientY);
};

this.addPart = function (x, y, placeFirst, noSelectNewPart) {
  if (_this.canvas.isViewOnly()) {
    return;
  }

  if (_upsellUi.usui.userIsOverLimit()) {
    _this.canvas.showPaymentModal();
    return;
  }

  _this.instance.unsetIsNewNode();
  _this.instance.dirtyAncestors();
  var children = _this.instance.children();
  var nextOrderIndex = 1;

  if (placeFirst) {
    // put node first in the list
    if (children.length) {
      nextOrderIndex = children[0].orderIndex * 0.9;
    }
  } else {
    if (children.length) {
      nextOrderIndex = children[children.length - 1].orderIndex + 1;
    }
  }

  var attrs = {
    id: (0, _uuid.uuid)(),
    title: '',
    summary: '',
    parentId: _this.id,
    createdById: window.user_id, // TODO: rely on backend for this
    orderIndex: nextOrderIndex,
    isNewNode: true
  };

  if (x !== undefined && y !== undefined) {
    var offset = $(_this.childNodesTag.refs.childNodes).offset();

    var _canvas$getMatrix2 = _this.canvas.getMatrix(),
        scale = _canvas$getMatrix2.scale,
        tx = _canvas$getMatrix2.tx,
        ty = _canvas$getMatrix2.ty;

    attrs.x = (x - offset.left - 64 * scale) / scale;
    attrs.y = (y - offset.top - 24 * scale) / scale;
  } else if (_this.instance.getLayoutName() === 'layout-freehand') {
    attrs.x = 10;
    attrs.y = 10;
  }

  var partId = _store_instance2.default.addNode(attrs);
  _this.canvas.nodesTag.update();
  var newPart = _this.canvas.nodeTags[partId];
  if (_this.instance.getLayoutName() === 'layout-freehand') {
    _nodesUi.nui.fitCardsIntoFreehand({ nodeTags: [newPart] });
  }
  newPart.discoverPosition();
  newPart.updateLayers({ callFocusTitle: true });
  _this.updateTopLevelNeighborsLite();
  if (!noSelectNewPart) {
    _this.canvas.toggleSelectedElement(newPart);
  }

  var messages = [];

  var _nui$fixOverlaps2 = _nodesUi.nui.fixOverlaps({
    nodeTag: newPart,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps2.prevNodePositions,
      nodePositions = _nui$fixOverlaps2.nodePositions;

  if (nodePositions.length) {
    messages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  messages.push(self.operation.messages.addNode({
    node: _store_instance2.default.getNode(partId)
  }));

  _perspectivesUi.pui.addNodeToActivePerspectives(newPart, messages);

  self.operation.batchOperation({
    messages: messages,
    onFailure: function onFailure(err) {
      console.log('batchOperation failure: ' + err);
    }
  });

  _appUi.appUI.zoomToCardIfZoomedOut(newPart);

  return partId;
};

this.handleTitleClick = function (e) {
  var canvas = _this.canvas;
  var shiftKey = e.shiftKey,
      target = e.target;

  e.preventDefault();
  e.stopPropagation();

  canvas.hidePopups();

  var linkTag = target.closest('a');
  if (linkTag) {
    if (!canvas.textToolbar.summoned) {
      var editableElement = _this.refs.title;
      var aIndex = Array.from(editableElement.querySelectorAll('a')).findIndex(function (a) {
        return a === linkTag;
      });
      canvas.externalLinkPopover.summon({
        aIndex: aIndex,
        editableElement: editableElement,
        href: linkTag.href,
        anchorTag: linkTag,
        nodeTag: _this,
        autoLinkified: linkTag.classList.contains('linkified')
      });
    }
  }

  _this.retainCurrentInputFocus = true;

  if (!canvas.isSelectedElement(_this.id)) {
    canvas.setSelectedElement(_this, shiftKey);
  }

  if (!shiftKey) {
    _this.focusTitle();
  }

  if (shiftKey && !window.getSelection().toString()) {
    _this.defocusTitle();
  }

  _this.updateTopLevelNeighborsLite();
  _searchUi.searchUI.unsetFocusedResult();
};

this.ignoreDblClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.handleSummaryClick = function (e) {
  var canvas = _this.canvas;
  var target = e.target;
  // at high zoom levels, disallow title editing

  e.preventDefault();
  e.stopPropagation();

  canvas.hidePopups();
  _this.instance.unsetIsNewNode();

  if (target.closest('a')) {
    var link = target.closest('a');

    var editableElement = _this.refs.summary;
    var aIndex = Array.from(editableElement.querySelectorAll('a')).findIndex(function (a) {
      return a === link;
    });

    canvas.externalLinkPopover.summon({
      aIndex: aIndex,
      editableElement: editableElement,
      href: link.href,
      anchorTag: link,
      nodeTag: _this,
      autoLinkified: link.classList.contains('linkified')
    });
  }

  if (!e.shiftKey) {
    self.retainCurrentInputFocus = true;
    canvas.setSelectedElement(_this, e.shiftKey);
  }

  _this.focusSummary();
  _searchUi.searchUI.unsetFocusedResult();
};

this.isTitleFocused = function () {
  if (document.getElementById('node-title-frontage-' + _this.id) === document.activeElement) {
    return true;
  }
  return false;
};

this.defocusTitle = function () {
  var $focused = $(':focus');
  $focused.blur();
  window.getSelection().removeAllRanges();
};

/* focus on a dummy input field so that pasting images in Firefox works */
this.focusDummyInput = function () {
  self.canvas.dummyInputTag.focus();
};

this.focusTitle = function (clear, expand) {
  if (_this.canvas.isViewOnly()) {
    return;
  }

  var _refs = _this.refs,
      title = _refs.title,
      sizerTitle = _refs.sizerTitle;

  if (clear) {
    title.innerHTML = '';
    sizerTitle.innerHTML = '';
  }

  if (expand) {
    _this.canvas.setSelectedElement(self);
  }

  if (!_this.isEditingTitle) {
    _this.isEditingTitle = true;
  }

  title.focus();
  _this.initialTitle = _this.instance.title;
  _collaboratorsUi.cui.sendPresence();

  if (_this.canvas.selectedElements.length <= 1) {
    var _canvas$getMatrix3 = _this.canvas.getMatrix(),
        scale = _canvas$getMatrix3.scale,
        tx = _canvas$getMatrix3.tx,
        ty = _canvas$getMatrix3.ty;

    var titleElement = document.getElementById('node-title-frontage-' + _this.id);
    var autocompleteTop = 0;

    if (titleElement) {
      autocompleteTop = titleElement.getBoundingClientRect().bottom;
    }

    _this.canvas.autocompleteTag.summon(_this.absolutePosition.x - 7, (autocompleteTop - ty) / scale, function (selection) {
      var title = selection.title;
      var summary = selection.summary;
      var librarySlug = selection.librarySlug;
      var externalIdentifier = selection.externalIdentifier;
      var canonicalNodeUUID = selection.canonicalNodeUUID;
      var tags = selection.tags;
      var messages = [];

      var prevValues = {
        title: self.instance.title,
        summary: self.instance.summary,
        librarySlug: self.instance.librarySlug,
        externalIdentifier: self.instance.externalIdentifier,
        canonicalNodeUUID: self.instance.canonicalNodeUUID,
        tags: self.instance.tags

        // if this is a perspective node, update the perspective title too
      };var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(self.id);
      if (perspective) {
        var m = _perspectivesUi.pui.editPointNodeTitleOperation({ perspective: perspective, title: title });
        messages.push(m);
      }

      self.instance.setTitle(title, []);
      self.instance.setSummary(summary, []);

      self.updateTitleDisplay();
      self.updateSummaryDisplay();

      self.resizeParent(true);

      self.instance.updateNode({ tags: tags, librarySlug: librarySlug, externalIdentifier: externalIdentifier, canonicalNodeUUID: canonicalNodeUUID });
      self.updateAll();

      if (perspective) {
        self.canvas.perspectivesListingTag.update();
        if (self.canvas.perspectiveBannerTag && !self.canvas.perspectiveBannerTag.isHidden) {
          self.canvas.perspectiveBannerTag.update();
        }
        _perspectivesUi.pui.updatePerspectiveNodeTagsDots(perspective.id);
        self.refreshPerspectiveHighlight();
      }

      messages.push(self.operation.messages.editNode({
        updates: { title: title, summary: summary, librarySlug: librarySlug, tagsList: tags, externalIdentifier: externalIdentifier, canonicalNodeUUID: canonicalNodeUUID },
        prevValues: prevValues,
        nodeUUID: self.instance.id
      }));

      self.updateWaypointsTitle({
        messages: messages,
        title: title,
        prevTitle: prevValues.title
      });

      self.operation.batchOperation({
        messages: messages,
        onFailure: function onFailure(e) {
          console.log('editNode failure: ' + e);
          self.flagErrorField('title');
          _appUi.appUI.stopTheWorldError();
        },
        onSuccess: self.editNodeSuccess(self)
      });
    });
  }
};

this.editNodeSuccess = function (node) {
  return function (res) {
    if (res.updates && res.updates.canonical_node_uuid) {
      var canonicalNodeUUID = res.updates.canonical_node_uuid;
      node.instance.updateNode({ canonicalNodeUUID: canonicalNodeUUID });
    }
  };
};

this.focusSummary = function () {
  if (_this.canvas.isViewOnly()) {
    return;
  }

  var summary = _this.refs.summary;

  if (!_this.isEditingSummary) {
    _this.isEditingSummary = true;
    summary.focus();
    _this.initialSummary = _this.instance.summary;
    _collaboratorsUi.cui.sendPresence();
  }
};

this.getMembershipSVGStyle = function () {
  var top = -1 * _this.getHeight();
  return 'top: ' + top + 'px';
};

this.getMembershipSVGHeight = function () {
  var height = _this.getHeight() + 100;
  if (height <= 0) {
    height = 1000;
  }
  return height;
};

this.updateAll = function () {
  self.updateLayers();
};

this.updatePosition = function () {
  var node = _store_instance2.default.getNode(_this.id);
  // only set x and y coords if we're in freehand mode or we're a top level node
  if (self.refs.container && node && (node.getGoverningLayoutName() == 'layout-freehand' || !node.parentId)) {
    var x = parseInt(node.x);
    var y = parseInt(node.y);
    // avoid invalidating layout if we're not changing anything
    if (self.refs.container.style.left !== x + 'px') {
      self.refs.container.style.left = x + 'px';
    }
    if (self.refs.container.style.top !== y + 'px') {
      self.refs.container.style.top = y + 'px';
    }
  }
  if (!_this.canvas.dragging) {
    _this.refreshZoomStepNodeSizes();
    _this.updateZoomLevelVisibilityClasses();
  }
};

this.nodeTopLineZoomClass = function () {
  return _nodesUi.nui.getNodeTopLineZoomClass(self);
};

this.updateStyle = function () {
  if (!self.refs.container) {
    return;
  }
  if (_this.getCurrentTitle()) {
    self.refs.nodeTopLine.classList.remove('empty-title');
  } else {
    self.refs.nodeTopLine.classList.add('empty-title');
  }
  _nodesUi.nui.updateNodeTopLineZoomClass(self);
  _this.setTextSizeAttribute();
};

this.updatePerspectiveDotStyle = function () {
  var nodePerspectiveDotsTag = _this.canvas.nodePerspectiveDotsTag[_this.id];
  if (nodePerspectiveDotsTag) {
    nodePerspectiveDotsTag.refreshAnnotations();
  }
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'].forEach(function (e) {
      return e.updateActiveState();
    });
  }
};

this.getEyeballBoundingBox = function () {
  if (_this.tags['node-eyeball']) {
    return _this.tags['node-eyeball'][1].refs.button.getBoundingClientRect();
  }
};

this.freshenEyeball = function () {
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'] && _this.tags['node-eyeball'].forEach(function (e) {
      return e.freshen();
    });
  }
};

this.showPreviewEyeball = function (color) {
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'].forEach(function (e) {
      return e.showPreviewEyeball(color);
    });
  }
};

this.unsetPreviewEyeball = function () {
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'].forEach(function (e) {
      return e.unsetPreviewEyeball();
    });
  }
};

this.hidePreviewEyeball = function () {
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'].forEach(function (e) {
      return e.hidePreviewEyeball();
    });
  }
};

this.setPointPerspective = function (p) {
  if (_this.tags['node-eyeball']) {
    _this.tags['node-eyeball'].forEach(function (e) {
      return e.setPointPerspective(p);
    });
  }
};

this.updatePerspectiveDots = function () {
  if (_this.tags['node-perspective-dots']) {
    var dotsList = _this.tags['node-perspective-dots'];
    for (var _iterator8 = dotsList, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
      var _ref10;

      if (_isArray8) {
        if (_i8 >= _iterator8.length) break;
        _ref10 = _iterator8[_i8++];
      } else {
        _i8 = _iterator8.next();
        if (_i8.done) break;
        _ref10 = _i8.value;
      }

      var dots = _ref10;

      dots._fetchNodePerspectives();
      dots.update();
      dots.refreshAnnotations();
    }
    var annotations = _this.getPerspectiveAnnotationsTag();
    annotations._fetchNodePerspectives();
    annotations.update();
  }
};

this.getPerspectiveAnnotationsTag = function () {
  return _this.tags['node-perspective-annotations'];
};

this.getPerspectiveDots = function () {
  return _this.canvas.nodePerspectiveDotsTag[_this.id];
};

this.getPointPerspective = function () {
  return _store_instance2.default.getPerspectives().find(function (p) {
    return p.pointNodeUUID == _this.id && !p.hidden;
  });
};

this.updateSearchResultDisplay = function () {
  if (_searchUi.searchUI.isInSearchResults(_this.id)) {
    var node = _store_instance2.default.getNode(_this.id);
    _searchUi.searchUI.styleResultNode(node);
    if (_searchUi.searchUI.isFocusedSearchResult(_this.id)) {
      _searchUi.searchUI.setFocusedHighlight(node);
    }
  }
};

this.setSelected = function () {
  _this.computeExpanded();
  if (_this.refs.container) {
    _this.refs.container.classList.add('selected');
    if (_this.expanded) {
      _this.refs.nodeTopLine.classList.add('node-top-line-selected');
      _this.refs.nodeTopLineSizer.classList.add('node-top-line-sizer-selected');
      _this.refs.container.classList.add('expanded');
    } else {
      _this.refs.container.classList.remove('expanded');
      _this.refs.nodeTopLine.classList.remove('node-top-line-selected');
      _this.refs.nodeTopLineSizer.classList.remove('node-top-line-sizer-selected');
    }
  }
  _this.updateDummyInputFocus();
};

this.updateDummyInputFocus = function () {
  if (!_this.retainCurrentInputFocus) {
    _this.focusDummyInput();
  }
  _this.retainCurrentInputFocus = false;
};

this.unsetSelected = function () {
  var previouslyExpanded = _this.expanded;
  var _refs2 = _this.refs,
      title = _refs2.title,
      container = _refs2.container,
      nodeTopLine = _refs2.nodeTopLine,
      nodeTopLineSizer = _refs2.nodeTopLineSizer;

  _this.expanded = false;

  if (_this.instance.isNewNode) {
    _this.instance.unsetIsNewNode();
  }

  if (previouslyExpanded) {
    /*
     when we're zoomed out and editing a title, and click off the node
     when we remove the class 'node-top-line-selected' below then title.innerText becomes blank for some reason.
     Calling blur here triggers editTitle which saves the title before it otherwise disappears...
    */
    if (title && _zoomUi.zoomUI.currentScale <= _zoomUi.zoomUI.ZOOM_THRESHOLD_0) {
      title.blur();
    }
  }

  if (container) {
    if (container.classList.contains('selected') || container.classList.contains('expanded')) {
      container.classList.remove('expanded', 'selected');
    }
    if (nodeTopLine.classList.contains('node-top-line-selected')) {
      nodeTopLine.classList.remove('node-top-line-selected');
    }
    if (nodeTopLineSizer.classList.contains('node-top-line-sizer-selected')) {
      nodeTopLineSizer.classList.remove('node-top-line-sizer-selected');
    }
  }

  if (previouslyExpanded) {
    _this.updateTopLevelNeighborsLite();
    if (_this.instance.link()) {
      var linkTag = _this.canvas.linkTags[_this.instance.link().id];
      linkTag.updatePosition();
    }
  }
};

this.setUndraggable = function () {
  if (_this.refs.container) {
    _this.refs.container.classList.add('undraggable');
  }
};

this.updateSelectedState = function () {
  _this.computeExpanded();
  if (_this.canvas.getSelectedElementIds().includes(_this.id)) {
    _this.setSelected();
  } else {
    _this.unsetSelected();
  }
};

this.computeExpanded = function () {
  _this.expanded = _this.canvas.getSelectedElementIds().includes(_this.id) && !_this.canvas.selecting && _this.canvas.getSelectedElementIds().length === 1 && (!document.body.classList.contains('show-tag-selected') || _this.refs.container.classList.contains('tag-selected'));
  return _this.expanded;
};

this.showAlternateTitles = function () {
  _this.alternateTitlesExpanded = true;
};

this.hideAlternateTitles = function () {
  _this.alternateTitlesExpanded = false;
};

// update hidden css state to match store state
this.updateHiddenState = function () {
  var node = _store_instance2.default.getNode(_this.id);
  if (node.isCollapsed) {
    _this.refs.container.classList.add('collapsed');
  } else {
    _this.refs.container.classList.remove('collapsed');
  }

  if (!node.isShownNodeType() || node.hidden) {
    _this.refs.container.classList.add('hidden');
  } else {
    _this.refs.container.classList.remove('hidden');
  }
};

this.updateChildDisplayState = function () {
  var node = _store_instance2.default.getNode(_this.id);
  var _refs3 = _this.refs,
      container = _refs3.container,
      expandTool = _refs3.expandTool,
      partBarTool = _refs3.partBarTool;

  if (node.children().length) {
    expandTool.classList.add('has-children');
    container.classList.add('container-has-children');

    if (node.getIsCollapsed()) {
      expandTool.classList.add('fa-angle-up', 'node-collapsed');
      expandTool.classList.remove('fa-angle-down', 'node-expanded');
      partBarTool.classList.add('collapsed');
    } else {
      expandTool.classList.add('fa-angle-down', 'node-expanded');
      expandTool.classList.remove('fa-angle-up', 'node-collapsed');
      partBarTool.classList.remove('collapsed');
    }
  } else {
    expandTool.classList.remove('has-children');
    container.classList.remove('container-has-children');
  }

  if (!node.getIsCollapsed()) {
    expandTool.title = 'collapse';
  } else {
    expandTool.title = 'expand';
  }
};

// style this node as a link node
this.updateLinkNodeState = function () {
  var node = _store_instance2.default.getNode(_this.id);
  if (node.link()) {
    _this.refs.container.classList.add('relationship');
  } else {
    _this.refs.container.classList.remove('relationship');
  }
};

this.updateLayers = function (params) {
  params = Object.assign({ forceUpdate: true }, params);
  if (self.canvas.nodeTags[self.id]) {
    self.canvas.nodeTags[self.id].update(params);
  }
};

// update links connecting to this node and its children
this.updateLinks = function () {
  var allLinks = _this.instance.descendantsLinks();
  if (!allLinks || !allLinks.length) {
    return;
  }
  var linkedUpdated = {};
  for (var _iterator9 = allLinks, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
    var _ref11;

    if (_isArray9) {
      if (_i9 >= _iterator9.length) break;
      _ref11 = _iterator9[_i9++];
    } else {
      _i9 = _iterator9.next();
      if (_i9.done) break;
      _ref11 = _i9.value;
    }

    var link = _ref11;

    if (self.canvas.linkTags[link.id]) {
      if (!linkedUpdated[link.id]) {
        //self.canvas.linkTags[link.id].update({ignorePlaceLinkNode: true});
        self.canvas.linkTags[link.id].updatePosition();
        linkedUpdated[link.id] = 1;
      }
    }
  }
};

// rediscover and update links connecting to this node and its children
this.rediscoverLinkPositions = function () {
  var allLinks = void 0;
  if (_this.canvas.dragging) {
    allLinks = _this.instance.descendantsLinksMinimal();
  } else {
    allLinks = _this.instance.descendantsLinks();
  }
  if (!allLinks || !allLinks.length) {
    return;
  }

  var seen = {};
  var linkedUpdated = {};
  for (var _iterator10 = allLinks, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
    var _ref12;

    if (_isArray10) {
      if (_i10 >= _iterator10.length) break;
      _ref12 = _iterator10[_i10++];
    } else {
      _i10 = _iterator10.next();
      if (_i10.done) break;
      _ref12 = _i10.value;
    }

    var link = _ref12;

    if (self.canvas.linkTags[link.id]) {
      var fromNode = link.fromNode().getFirstVisibleAncestorNode();
      var toNode = link.toNode().getFirstVisibleAncestorNode();

      if (!seen[fromNode.id] && self.canvas.nodeTags[fromNode.id]) {
        self.canvas.nodeTags[fromNode.id].discoverPosition();
        seen[fromNode.id] = 1;
      }

      if (!seen[toNode.id] && self.canvas.nodeTags[toNode.id]) {
        self.canvas.nodeTags[toNode.id].discoverPosition();
        seen[toNode.id] = 1;
      }

      if (!linkedUpdated[link.id]) {
        var linkTag = self.canvas.linkTags[link.id];
        linkTag.updateHiddenState();
        linkTag.updatePosition();
        linkTag.updateCollapsedState();
        linkedUpdated[link.id] = 1;
      }
    }
  }
};

/*
 * prevent browser from adding a <br> tag to the element after the user deletes its contents
 */
this.cleanupContent = function (key) {
  var element = _this.refs[key];
  if (element && element.innerHTML.match(/^<br\/?>$/)) {
    element.innerText = '';
  }
};

this.updateWaypointsTitle = function (_ref13) {
  var messages = _ref13.messages,
      title = _ref13.title,
      prevTitle = _ref13.prevTitle;

  var presentation = _store_instance2.default.getPresentation();

  if (presentation) {
    var updatedWaypoints = presentation.updateWaypointsTitle({
      nodeId: _this.id,
      prevTitle: prevTitle,
      title: title
    });

    if (updatedWaypoints.length) {
      var presentationUUID = presentation.id;
      var updatePresentationWaypointTitle = _this.operation.messages.updatePresentationWaypointTitle;

      updatedWaypoints.forEach(function (_ref14) {
        var waypointUUID = _ref14.id;
        return messages.push(updatePresentationWaypointTitle({
          presentationUUID: presentationUUID,
          waypointUUID: waypointUUID,
          title: title,
          prevTitle: prevTitle
        }));
      });

      _waypointsUi2.default.updateWaypoints();
    }
  }
};

this.editTitle = function (e) {
  _this.isEditingTitle = false;

  if (_this.canvas.isViewOnly()) {
    return;
  }

  if (_this.moribund) return;
  if (document.activeElement == e.target) return;

  _this.updateLayers();

  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _this.refs.title.blur();
  _collaboratorsUi.cui.sendPresence();

  var selectedAutocompleteResult = _this.canvas.autocompleteTag.getSelectedResult();
  if (selectedAutocompleteResult) {
    // if we selected an autocomplete result with the down arrow, go through makeSelection
    _this.canvas.autocompleteTag.makeSelection(selectedAutocompleteResult);
    return;
  }

  var _richText$encode = _richText2.default.encode(self.refs.title.innerHTML.trim()),
      title = _richText$encode.text,
      titleMeta = _richText$encode.meta;

  var node = _store_instance2.default.getNode(_this.id);

  var prevTitle = node.getTitle();
  var prevTitleMeta = prevTitle.meta;

  if (!node) {
    console.log('trying to edit a node that doesnt exist!');
    return;
  }

  node.setTitle(title, titleMeta);
  _this.setCurrentTitle();

  // don't wipe out the dom if we're editing a link
  if (!(_this.canvas.textToolbar.summoned && !_this.canvas.textToolbar.toolbarUsed)) {
    _this.updateTitleDisplay();
  }

  if (title.length === 0) {
    self.refs.title.innerHTML = _richText2.default.decode(prevTitle);
  }
  if (!prevTitle && !title && !_this.parentId && !_this.children && _this.instance.isNewNode) {
    return _this.destroy();
  }

  if (title == prevTitle && JSON.stringify(prevTitleMeta) == JSON.stringify(titleMeta)) {
    return;
  }

  // if this is a perspective node, update the perspective title too
  var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.id);
  var messages = [];
  if (perspective) {
    var m = _perspectivesUi.pui.editPointNodeTitleOperation({ perspective: perspective, title: title });
    _perspectivesUi.pui.refreshPerspectiveLists();
    if (m) messages.push(m);
  }
  messages.push(_this.operation.messages.editNode({
    updates: { title: title, titleMeta: titleMeta },
    prevValues: { title: prevTitle, titleMeta: prevTitleMeta },
    nodeUUID: self.instance.id
  }));

  _this.updateWaypointsTitle({ messages: messages, title: title, prevTitle: prevTitle });
  self.update({ forceUpdate: true });
  self.updateTopLevelNeighborsLite();
  if (_this.getChildrenDetached()) {
    _this.childNodesTag.updateDetachedTitle();
  }

  var _nui$fixOverlaps3 = _nodesUi.nui.fixOverlaps({
    nodeTag: _this,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps3.prevNodePositions,
      nodePositions = _nui$fixOverlaps3.nodePositions;

  if (nodePositions.length) {
    messages.push(_this.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  _this.operation.batchOperation({
    messages: messages,
    onFailure: function onFailure(e) {
      console.log('editNode failure: ' + e);
      self.flagErrorField('title');
      _appUi.appUI.stopTheWorldError();
    },
    onSuccess: self.editNodeSuccess(self)
  });

  _this.setLinkIsHidden();
  _this.updateTitleDisplay();

  if (perspective) {
    _this.canvas.perspectivesListingTag.update();
    if (_this.canvas.perspectiveBannerTag && !_this.canvas.perspectiveBannerTag.isHidden) {
      _this.canvas.perspectiveBannerTag.update();
    }
    _perspectivesUi.pui.updatePerspectiveNodeTagsDots(perspective.id);
    _this.refreshPerspectiveHighlight();
  }
  _collaboratorsUi.cui.dismissElementChangedBanner();
  _searchUi.searchUI.refreshResults();
};

this.setLinkIsHidden = function () {
  var nodeId = _this.id;

  _this.getTitleAndSummaryLinks().filter(function (url) {
    return !_sitePreviewUi.spUI.getLinkStates({ nodeId: nodeId, url: url });
  }).forEach(function (url) {
    return _sitePreviewUi.spUI.setLinkIsHidden({ url: url, nodeTag: _this, isHidden: false });
  });
};

this.getCurrentTitle = function (fresh) {
  fresh && _this.setCurrentTitle();
  return _this._currentTitle || '';
};

this.setCurrentTitle = function () {
  var node = _store_instance2.default.getNode(_this.id);
  if (!node) return;
  var title = node.getTitle();
  _this._currentTitle = _richText2.default.decode({ text: title, meta: title.meta });
};

this.getCurrentSummary = function (fresh) {
  fresh && _this.setCurrentSummary();
  return _this._currentSummary || '';
};

this.setCurrentSummary = function () {
  var node = _store_instance2.default.getNode(_this.id);
  if (!node) return;
  var summary = node.getSummary();
  _this._currentSummary = _richText2.default.decode({ text: summary, meta: summary.meta });
};

this.revertTitle = function (e) {
  // if escape key is pressed
  // revert the title if there was a previous title in this node
  // or remove the node if it didn't have a title
  var title = self.refs.title.innerText;
  var prevTitle = self.instance.getTitle();
  if (prevTitle) {
    self.refs.title.innerHTML = _richText2.default.decode({
      text: prevTitle,
      meta: prevTitle.meta
    });
    self.updateAll();
  } else if (_this.instance.isNewNode) {
    e.stopPropagation();
    _this.destroy(false);
  }
};

// wipe out this node
this.destroy = function () {
  var setUndoBanner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  _this.moribund = true;
  self.canvas.deleteNode(_this.id, setUndoBanner);
  self.unmount();
};

this.setDetachedChildrenDimensions = function () {
  var container = _this.childNodesTag.refs.container;
  container.style.minWidth = _this.instance.childrenPosition.userWidth + 'px';
  container.style.minHeight = _this.instance.childrenPosition.userHeight + 'px';
};

this.fitChildNodeContentsAndUpdate = function (id) {
  var childNodesTag = self.canvas.nodeTags[id].childNodesTag;
  if (!childNodesTag && self.hasChildren()) {
    self.update();
  } else if (childNodesTag) {
    childNodesTag.fitToContents();
    childNodesTag.update();
  }
  _this.discoverPosition();
};

this.editSummary = function (e) {
  _this.isEditingSummary = false;

  if (_this.canvas.isViewOnly()) {
    return;
  }
  if (_this.moribund) return;
  if (document.activeElement == e.target) return;

  e.preventDefault();
  e.stopPropagation();

  self.refs.summary.blur();
  _collaboratorsUi.cui.sendPresence();

  var node = _this.canvas.store.getNode(_this.id);

  var _richText$encode2 = _richText2.default.encode(self.refs.summary.innerHTML.trim()),
      summary = _richText$encode2.text,
      summaryMeta = _richText$encode2.meta;

  var prevSummary = node.getSummary();
  var prevSummaryMeta = prevSummary.meta;

  node.setSummary(summary, summaryMeta);

  _this.setCurrentSummary();

  var messages = [];

  // don't wipe out the dom if we're editing a link
  if (!(_this.canvas.textToolbar.summoned && !_this.canvas.textToolbar.toolbarUsed)) {
    _this.updateSummaryDisplay();
  }

  _this.update({ forceUpdate: true });
  messages.push(self.operation.messages.editNode({
    updates: { summary: summary, summaryMeta: summaryMeta },
    prevValues: { summary: prevSummary, summaryMeta: prevSummaryMeta },
    nodeUUID: node.id
  }));

  var _nui$fixOverlaps4 = _nodesUi.nui.fixOverlaps({
    nodeTag: _this,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps4.prevNodePositions,
      nodePositions = _nui$fixOverlaps4.nodePositions;

  if (nodePositions.length) {
    messages.push(_this.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  var plecticaLinks = _this.getTitleAndSummaryLinks();

  if (plecticaLinks.length) {
    for (var _iterator11 = plecticaLinks, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
      var _ref15;

      if (_isArray11) {
        if (_i11 >= _iterator11.length) break;
        _ref15 = _iterator11[_i11++];
      } else {
        _i11 = _iterator11.next();
        if (_i11.done) break;
        _ref15 = _i11.value;
      }

      var url = _ref15;

      if (!_sitePreviewUi.spUI.getLinkStates({ nodeId: _this.id, url: url })) {
        _sitePreviewUi.spUI.setLinkIsHidden({
          nodeTag: _this,
          url: url,
          isHidden: false
        });
      }
    }
  }

  // disabling perspective summaries in prototype
  if (false) {
    _perspectivesUi.pui.editNodeSummary(self, summary, prevSummary);
  } else {
    self.operation.batchOperation({
      messages: messages,
      onSuccess: _this.editNodeSuccess(self),
      onFailure: function onFailure(e) {
        console.log('editNode failure: ' + e);
        self.flagErrorField('summary');
        _appUi.appUI.stopTheWorldError();
      }
    });
    self.updateLayers();
    _collaboratorsUi.cui.dismissElementChangedBanner();
  }
};

this.getLinkId = function () {
  return _this.instance.link();
};

this.getRelationshipClassName = function () {
  var link = _this.instance.link();
  if (link) {
    return 'relationship relationship-' + link.color;
  } else {
    return '';
  }
};

this.isDragSubject = function () {
  return _this.canvas.dragging == _this.id;
};

this.recordPosition = function () {
  var x = self.instance.x;
  var y = self.instance.y;
  self.instance.setAbsolutePosition({ x: x, y: y });
};

this.discoverPositionOfDescendants = function () {
  var children = _this.instance.descendants();
  children.forEach(function (n) {
    if (self.canvas.nodeTags[n.id]) {
      self.canvas.nodeTags[n.id].discoverPosition();
    }
  });
};

this.refreshPerspectiveHighlight = function () {
  var perspectives = _perspectivesUi.pui.getActivePerspectives();
  if (perspectives.some(function (p) {
    return p.hasMemberNode(_this.id) || p.isPointNode(_this.id);
  })) {
    _this.perspectiveHighlight();
  } else {
    _this.perspectiveUnHighlight();
  }
};

this.perspectiveHighlight = function () {
  _this.perspectiveHighlighted = true;
  if (_this.refs.container && !_this.refs.container.classList.contains('tag-selected')) {
    _this.refs.container.classList.add('tag-selected');
  }
  var parent = self.topLevelParentTag();
  if (parent && parent.id !== _this.id && parent && parent.refs && parent.refs.container && !parent.refs.container.classList.contains('parent-of-tag-selected')) {
    parent.refs.container.classList.add('parent-of-tag-selected');
  }
};

this.perspectiveUnHighlight = function () {
  _this.perspectiveHighlighted = false;
  if (_this.refs.container) {
    _this.refs.container.classList.remove('tag-selected');
  }
  var parent = self.topLevelParentTag();
  if (parent && parent.refs && parent.refs.container && !parent.refs.container.querySelector('.tag-selected')) {
    parent.refs.container.classList.remove('parent-of-tag-selected');
  }
};

this.setTransparent = function () {
  if (_this.refs.container) {
    _this.refs.container.classList.add('transparency');
  }
  _this.isTransparent = true;
};

this.unsetTransparent = function () {
  if (_this.refs.container) {
    _this.refs.container.classList.remove('transparency');
  }
  _this.isTransparent = false;
};

this.discoverPosition = function () {
  var node = _store_instance2.default.getNode(_this.id);

  if (node.hidden) {
    return;
  }
  if (!self.refs || !self.refs.container) {
    return;
  }

  var x = void 0;
  var y = void 0;

  if (!node.parentId) {
    // node is where we put it if it is top-level
    node.setAbsolutePosition({ x: node.x, y: node.y });

    if (!node.width || !node.height) {
      var width = self.refs.container.offsetWidth;
      var height = self.refs.container.offsetHeight;
      node.setDimensions({ width: width, height: height });
    }
    return { x: node.x, y: node.y };
  } else {

    var el = self.refs.container;

    x = el.offsetLeft;
    y = el.offsetTop;
    var offsetParent = el.offsetParent;
    var guard = 1000;

    while (offsetParent && offsetParent.getAttribute('id') != 'nodes' && guard--) {
      x += offsetParent.offsetLeft;
      y += offsetParent.offsetTop;
      offsetParent = offsetParent.offsetParent;
    }

    var _width = el.offsetWidth;
    var _height = el.offsetHeight;
    node.setAbsolutePosition({ x: x, y: y });
    node.setDimensions({ width: _width, height: _height });
  }

  _this.refreshZoomStepNodeSizes();
  node.setCollapsedChildrenPosition(_this.discoverCollapsedChildrenPosition());

  return { x: x, y: y };
};

this.discoverCollapsedChildrenPosition = function () {

  if (!_this.hasChildren() || !_this.getIsCollapsed()) {
    return _this.instance.collapsedChildrenPosition;
  }

  var el = _this.refs.colGroupContainer;

  var x = el.offsetLeft;
  var y = el.offsetTop;
  var offsetParent = el.offsetParent;
  var guard = 1000;

  while (offsetParent && offsetParent.getAttribute('ref') != 'backdrop' && guard--) {
    x += offsetParent.offsetLeft;
    y += offsetParent.offsetTop;
    offsetParent = offsetParent.offsetParent;
  }

  return { x: x, y: y };
};

this.getZoomTextClass = function () {
  var _instance2 = _this.instance,
      width = _instance2.width,
      height = _instance2.height,
      title = _instance2.title;

  var ptSize = Math.sqrt(width * height / (title ? title.length : 1));

  return ptSize > 40 ? 40 : ptSize > 35 ? 36 : ptSize > 30 ? 32 : 26;
};

/*
  get position after transforms (specifically relationship cards with their 50% translateX)
*/
this.getRenderedPosition = function () {
  var rect = _this.refs.container.getBoundingClientRect();
  var mapCoords = _appUi.appUI.viewportCoordsToMapCoords(rect);

  var _self$canvas$getMatri = self.canvas.getMatrix(),
      scale = _self$canvas$getMatri.scale;

  var width = (rect.right - rect.left) / scale;
  var height = (rect.bottom - rect.top) / scale;

  mapCoords.width = width;
  mapCoords.height = height;
  return mapCoords;
};

this.refreshZoomStepNodeSizes = function () {
  if (_this.canvas.dragging) return;
  var currentNode = _this.canvas.store.getNode(_this.id);
  if (!currentNode) return;

  var zoomSteps = _zoomUi.zoomUI.getZoomSteps();
  // predict the footprint of title signposts at each zoom level
  var title = self.getCurrentTitle();

  for (var _iterator12 = zoomSteps, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
    var _ref16;

    if (_isArray12) {
      if (_i12 >= _iterator12.length) break;
      _ref16 = _iterator12[_i12++];
    } else {
      _i12 = _iterator12.next();
      if (_i12.done) break;
      _ref16 = _i12.value;
    }

    var _step = _ref16;

    if (!_this.willShowZoomSignpost()) {
      if (_zoomUi.zoomUI.zoomStepNodeSizes[_step.zoomLevel]) {
        delete _zoomUi.zoomUI.zoomStepNodeSizes[_step.zoomLevel][_this.id];
      }
      continue;
    }
    /* estimating signpost footprint / font sizes / etc */
    var width = Math.min(title.length * _step.inverse * 16 + 12 * _step.inverse, 600);
    var height = 42 * _step.inverse;
    var infoWidth = Math.min(currentNode.width, 300);
    var top = currentNode.absolutePosition.y - 60 * _step.inverse;
    var left = currentNode.absolutePosition.x + infoWidth / 2 - width / 2;
    var signpostBoundingBox = {
      step: _step,
      width: width,
      height: height,
      top: top,
      left: left,
      right: left + width,
      bottom: top + height
    };
    if (!_zoomUi.zoomUI.zoomStepNodeSizes[_step.zoomLevel]) {
      _zoomUi.zoomUI.zoomStepNodeSizes[_step.zoomLevel] = {};
    }
    _zoomUi.zoomUI.zoomStepNodeSizes[_step.zoomLevel][_this.id] = signpostBoundingBox;
  }
};

/*
  for debugging purposes.  don't delete me
  let's us see where we predict the footprint of a signpost will be at a certain zoom level
*/
this.drawSignpostBox = function (zoomLevel) {
  var box = _zoomUi.zoomUI.zoomStepNodeSizes[zoomLevel][self.instance.id];
  $(_this.canvas.refs.nodes).prepend($('<div style="position: absolute; left: ' + box.left + 'px; top: ' + box.top + 'px; width: ' + box.width + 'px; height: ' + box.height + 'px; background: rgba(255,0,0,0.5); z-index: 99999;"></div>'));
};

this.getStyledCardClasses = function () {
  return 'styled-card styled-card--' + _this._getDisplayStyle();
};

this.getTitleLengthClass = function () {
  var title = _this.title || '';
  var unbreakable = title.length <= 15 && !/\b\s+\b/.test(title);
  return unbreakable ? 'title--unbreakable' : 'title--breakable';
};

this.updateZoomLevelVisibilityClasses = function () {
  var zoomStepOverlaps = _zoomUi.zoomUI.getZoomStepOverlaps(_this.id);
  var classes = [];
  var node = self.canvas.store.getNode(_this.id);

  if (!node) {
    return;
  }

  node.setZoomLevelHidden(null);
  if (self.refs.nodeTopLine) {
    self.refs.nodeTopLine.setAttribute('data-zoom-hidden', 0);
  }
  if (!_this.willShowZoomSignpost()) {
    return;
  }
  for (var zoomLevel in zoomStepOverlaps) {
    if (!_this.visibleAtZoomLevel(zoomLevel, zoomStepOverlaps)) {
      node.setZoomLevelHidden(zoomLevel);
      if (self.refs.nodeTopLine) {
        self.refs.nodeTopLine.setAttribute('data-zoom-hidden', zoomLevel);
      }
      break;
    }
  }
};

// top level nodes and nodes in top level freehand containers can show signposts at high zoom.  Nobody else will
// also nodes with blank titles won't show
this.willShowZoomSignpost = function () {
  if (!_this.instance.title) {
    return false;
  }
  if (!_this.instance.parentId) {
    return true;
  }
  if (_this.instance.parentId && _this.instance.getParent().parentId) {
    return false;
  }
  if (_this.instance.getGoverningLayoutName() != 'layout-freehand') {
    return false;
  }
  return true;
};

this.visibleAtZoomLevel = function (zoomLevel, zoomStepOverlaps) {

  if (!zoomStepOverlaps[zoomLevel] || !zoomStepOverlaps[zoomLevel].length) {
    return true;
  }

  return zoomStepOverlaps[zoomLevel].every(function (id) {
    var node = _store_instance2.default.getNode(id);
    if (id == self.instance.id) {
      return true;
    }
    return _nodesUi.nui.zoomPrecendenceOver(_this.instance, node, parseFloat(zoomLevel));
  });
};

this.getAllSelectedNodeAndLinkIds = function () {
  return _nodesUi.nui.computeAllSelectedMovingParts(_store_instance2.default, _this.instance, _this.canvas);
};

this.getTargetNodeAndLinkIds = function (instance) {
  return _nodesUi.nui.computeMovingParts(_store_instance2.default, instance);
};

this.placeLinkNodesRecursively = function (instance) {
  var appliedPlaceLinkNodes = {};
  var nodeIdsToUpdate = [];

  var placeLinkNodes = function placeLinkNodes(startingNode) {
    if (appliedPlaceLinkNodes[startingNode.id]) {
      return;
    }
    appliedPlaceLinkNodes[startingNode.id] = 1;
    if (_store_instance2.default.getNode(startingNode.id).link()) {
      nodeIdsToUpdate.push(startingNode.id);
    }
    for (var _iterator13 = startingNode.links(), _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
      var _ref17;

      if (_isArray13) {
        if (_i13 >= _iterator13.length) break;
        _ref17 = _iterator13[_i13++];
      } else {
        _i13 = _iterator13.next();
        if (_i13.done) break;
        _ref17 = _i13.value;
      }

      var link = _ref17;

      if (link.linkNodeId && link.linkNode()) {
        link.placeLinkNode();
        placeLinkNodes(link.linkNode());
      }
    }
    for (var _iterator14 = startingNode.children(), _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
      var _ref18;

      if (_isArray14) {
        if (_i14 >= _iterator14.length) break;
        _ref18 = _iterator14[_i14++];
      } else {
        _i14 = _iterator14.next();
        if (_i14.done) break;
        _ref18 = _i14.value;
      }

      var child = _ref18;

      placeLinkNodes(child);
    }
  };

  placeLinkNodes(instance);

  var linkedUpdated = {};
  for (var _iterator15 = nodeIdsToUpdate, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
    var _ref19;

    if (_isArray15) {
      if (_i15 >= _iterator15.length) break;
      _ref19 = _iterator15[_i15++];
    } else {
      _i15 = _iterator15.next();
      if (_i15.done) break;
      _ref19 = _i15.value;
    }

    var id = _ref19;

    var allLinks = _store_instance2.default.getNode(id).descendantsLinks();
    if (!allLinks || !allLinks.length) {
      continue;
    }
    for (var _iterator16 = allLinks, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
      var _ref20;

      if (_isArray16) {
        if (_i16 >= _iterator16.length) break;
        _ref20 = _iterator16[_i16++];
      } else {
        _i16 = _iterator16.next();
        if (_i16.done) break;
        _ref20 = _i16.value;
      }

      var link = _ref20;

      if (self.canvas.linkTags[link.id]) {
        if (!linkedUpdated[link.id]) {
          self.canvas.linkTags[link.id].updatePosition();
          linkedUpdated[link.id] = 1;
        }
      }
    }
  }
};

this.setTextSizeAttribute = function () {
  var zoomTextClass = _this.getZoomTextClass();
  [_this.refs.title, _this.refs.sizerTitle, _this.refs.highlightTitle].forEach(function (el) {
    el.setAttribute('data-zoom-text-size', zoomTextClass);
  });
};

this.enablePerspectiveEyeballTags = false;
this.enablePerspectiveDotTags = false;

this.mousePannable = function (e) {
  var target = $(e.target);
  if (target.hasClass('child-nodes') && target.hasClass('layout-freehand')) {
    return true;
  }
  return false;
};

this.on('update', function () {
  _this.setCurrentTitle();
  _this.setCurrentSummary();
});

this.on('updated', function () {
  _this.setTextSizeAttribute();
  if (self.callFocusTitle) {
    window.requestAnimationFrame(function () {
      self.focusTitle();
      delete self.callFocusTitle;
    });
  }

  _this.lightboxListener();

  if (_this.instance.link()) {
    _this.canvas.linkTags[_this.instance.link().id].update();
  }

  _this.computeExpanded();

  if (_this.showImage()) {
    (0, _nodeDragHandlers.setupHandleImageResizing)({
      canvas: _this.canvas,
      handleRef: _this.refs.imageResizeHandle,
      nodeTag: _this
    });
  }
});

// initialize dragging
this.on('mount', function () {
  _this.setCurrentTitle();
  _this.setCurrentSummary();

  _this.canvas.nodeTags[_this.id] = _this;

  // call this once all nodes are mounted
  if (Object.keys(_this.canvas.nodeTags).length == _store_instance2.default.nodes.size) {
    _this.canvas.postInitialization();
  }

  if (!_this.canvas.isViewOnly()) {
    (0, _nodeDragHandlers.setupNodeDragging)({ canvas: _this.canvas, nodeTag: _this });
    (0, _nodeDragHandlers.setupHandleNodeResizing)({
      canvas: _this.canvas,
      handleRef: _this.refs.nodeResizeHandle,
      nodeTag: _this
    });
  }

  _this.lightboxListener();

  if (_this.showImage() && !_this.canvas.isViewOnly()) {
    (0, _nodeDragHandlers.setupHandleImageResizing)({
      canvas: _this.canvas,
      handleRef: _this.refs.imageResizeHandle,
      nodeTag: _this
    });
  }

  _this.setIsNarrow();
});

this.shouldUpdate = function (data, opts) {
  if (data && data.forceUpdate) {
    return true;
  } else if (opts.instance._dirty) {
    _store_instance2.default.getNode(opts.instance.id).clean();
    return true;
  } else {
    return false;
  }
};

this.handleFileUpload = _nodesUi.nui.uploadHandler.bind(this);

this.handleDragOver = function (e) {
  e.preventDefault();
  e.stopPropagation();
};

this.handleDragEnter = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  };
  var targetId = e.target.getAttribute('data-id');
  var targetNode = _this.canvas.nodeTags[targetId];
  _this.canvas.setDragEnteredNode(targetNode);
};

this.handleDragLeave = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.canvas.setDragEnteredNode(null);
  /* toElement allows safari to work, but the state sticks after exiting the card -
    issue handled in handleMouseLeave()
  */
  var ancestor = $(e.relatedTarget || e.explicitOriginalTarget || e.toElement).closest('node .container, .detached > .child-nodes-container')[0];
  var ancestorId = void 0,
      ancestorTag = void 0;
  if (ancestor) {
    ancestorId = ancestor.getAttribute('data-id');
    if (ancestor.classList.contains('child-nodes-container')) {
      ancestorTag = _this.canvas.childNodeTags[ancestorId];
    } else {
      ancestorTag = _this.canvas.nodeTags[ancestorId];
    }
    var ancestorNode = ancestorTag.instance || ancestorTag.parent.instance;

    _this.canvas.setDragEnteredNode(ancestorTag);
  }
};

this.getImageStyle = function () {
  if (_constants.ALLOWED_IMAGE_FILE_TYPES.includes(_this.instance.attachedFile.file_type)) {
    var imageDimensions = _fileAttachmentsUi.fui.getImageDimensions(_this.id);
    if (imageDimensions) {
      return 'width: ' + imageDimensions.width + 'px; height: ' + imageDimensions.height + 'px';
    }
  }
  return '';
};

this.getImageWrapperStyle = function () {
  if (_constants.ALLOWED_IMAGE_FILE_TYPES.includes(_this.instance.attachedFile.file_type) || (0, _util.canPlayVideo)(_this.instance.attachedFile.file_type)) {
    var imageDimensions = _fileAttachmentsUi.fui.getImageDimensions(_this.id);
    if (imageDimensions && imageDimensions.width > _constants.WIDTHS.IMAGE_WRAPPER) {
      return 'max-width: ' + imageDimensions.width + 'px;';
    }
  }
  return '';
};

this.updateImageStyle = function () {
  if (_constants.ALLOWED_IMAGE_FILE_TYPES.includes(_this.instance.attachedFile.file_type)) {
    var imageDimensions = _fileAttachmentsUi.fui.getImageDimensions(_this.id);
    _this.setImageSize(imageDimensions);
  }
};

this.setImageSize = function (_ref21) {
  var width = _ref21.width,
      height = _ref21.height;
  var _refs4 = _this.refs,
      image = _refs4.image,
      imageWrapper = _refs4.imageWrapper;

  if (image) {
    image.style.width = width + 'px';
    image.style.height = height + 'px';
  }
  if (imageWrapper) {
    if (width > _constants.WIDTHS.IMAGE_WRAPPER) {
      imageWrapper.style.maxWidth = width + 'px';
    } else {
      imageWrapper.style.maxWidth = '';
    }
  }
};

this.getVideoStyle = function () {
  var videoDimensions = _fileAttachmentsUi.fui.getImageDimensions(_this.id);
  if (videoDimensions) {
    return 'width: ' + videoDimensions.width + 'px; height: ' + videoDimensions.height + 'px;';
  }
  return '';
};

this.getImageSrc = function () {
  if (_this.instance.attachedFile) {
    return _this.instance.attachedFile.preview_url || _this.instance.attachedFile.file_url;
  } else {
    return '';
  }
};

this.lightboxListener = function () {
  var _refs5 = _this.refs,
      imageWrapper = _refs5.imageWrapper,
      videoWrapper = _refs5.videoWrapper;

  if (imageWrapper) {
    (0, _interactjs2.default)(imageWrapper).on('tap', _this.showLightboxEvent);
  }
  if (videoWrapper) {
    (0, _interactjs2.default)(videoWrapper).on('tap', _this.showLightboxEvent);
  }
};

this.showLightboxEvent = function (e) {
  if (e.button !== 0) return;
  if (e.ctrlKey) return;
  if (e.shiftKey) {
    // make shift click change selection state
    return _this.screenClick(e);
  }

  e.stopImmediatePropagation();
  e.preventDefault();

  _this.showLightbox(e);
};

this.showLightbox = function (_ref22) {
  var button = _ref22.button,
      target = _ref22.target;
  var _refs6 = _this.refs,
      image = _refs6.image,
      video = _refs6.video;

  if (target === image || target === video) {
    _this.canvas.tags.gallery.summon({ node: _this.instance });
  }
};

this.screenClick = function (e) {
  if (_this.canvas.linkDragging) return;
  if (e.target.classList.contains('rel')) return;
  if (_this.canvas.rightClickMenuIsOpen()) {
    _this.canvas.hideRightClickMenu();
    return;
  }
  e.stopPropagation();
  if (_this.canvas.nodeToolsSummonTimeout) clearTimeout(_this.canvas.nodeToolsSummonTimeout);
  var nodePerspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.id);

  if (_this.isTitleFocused() && (_this.expanded || _this.isNewNode)) {
    /*
      if the title is focused and the card is clicked, defocus the title but keep the card selected
      and ensure that we can still paste images in Firefox...
    */
    _this.focusDummyInput();
  } else {
    _this.canvas.toggleSelectedElement(_this, e.shiftKey);
    if (!_this.canvas.isViewOnly() || _this.canvas.canCommentOnly()) {
      _this.canvas.nodeTools.summon({
        node: _this,
        summonedFromChildNodes: false,
        positionReferenceElement: _this.refs.container
      });
    }
  }

  _this.updateTopLevelNeighborsLite();

  if (!e.target.classList.contains('image-overlay')) {
    /* don't zoom in if we opened a lightbox */
    _appUi.appUI.zoomToCardIfZoomedOut(self);
  }

  if (_waypointsUi2.default.isAdding && !_this.parentId) {
    _waypointsUi2.default.addWaypoint({ nodeIds: [_this.id] });
  }

  var canvas = _this.canvas;
  var loadedComponentId = canvas.loadedComponentId,
      loadedTemplate = canvas.loadedTemplate;

  var cardTemplateTypes = ['basic-card', 'list-card', 'column-card', 'freehand-card'];

  if (loadedTemplate && cardTemplateTypes.includes(loadedComponentId)) {
    var position = {
      x: e.clientX,
      y: e.clientY
    };

    var _CopyPaste$pasteData = _copyPaste2.default.pasteData({
      data: loadedTemplate,
      forcedNewParent: _this,
      canvas: canvas,
      position: position
    }),
        nodeOldtoNewIds = _CopyPaste$pasteData.nodeOldtoNewIds;

    var topNode = canvas.store.getNode(Object.values(nodeOldtoNewIds)[0]).getTopLevelParent();
    var topNodeTag = canvas.nodeTags[topNode.id];
    topNodeTag.focusTitle(true);

    var messages = [];

    var _nui$fixOverlaps5 = _nodesUi.nui.fixOverlaps({ nodeTag: topNodeTag }),
        prevNodePositions = _nui$fixOverlaps5.prevNodePositions,
        nodePositions = _nui$fixOverlaps5.nodePositions;

    if (nodePositions.length) {
      messages.push(canvas.operation.messages.updateNodePositions({
        prevNodePositions: prevNodePositions,
        nodePositions: nodePositions,
        prevLinkAngles: [],
        linkAngles: []
      }));
    }

    canvas.operation.batchOperation({
      messages: messages,
      onFailure: function onFailure(err) {
        console.log('batchOperation failure: ' + err);
      }
    });

    canvas.creationTools.clearSelection();
  }
};

this.screenDoubleClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (_this.getLayoutName() == 'layout-freehand') {
    self.handleAddPart(e);
  };
};

this.getAnnotationsTag = function () {
  return _this.canvas.nodePerspectiveAnnotationsTag[_this.id];
};

this.stopRightClickPropagation = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  _this.canvas.hidePopups();
};

this.setImageMenuToggleActive = function () {
  if (_this.refs && _this.refs.imageMenuToggle) {
    _this.refs.imageMenuToggle.classList.add('active');
  }
};

this.unsetImageMenuToggleActive = function () {
  if (_this.refs && _this.refs.imageMenuToggle) {
    _this.refs.imageMenuToggle.classList.remove('active');
  }
};

this.toggleImageMenu = function (type, e) {
  e.preventDefault();
  e.stopPropagation();
  var nodeImageMenu = _this.canvas.nodeImageMenu;
  _this.canvas.hidePopups();
  if (nodeImageMenu.isOpen && nodeImageMenu.nodeTag && nodeImageMenu.nodeTag.id == _this.id) {
    _this.canvas.nodeImageMenu.hide();
  } else {
    _this.canvas.nodeImageMenu.summon({
      nodeTag: _this,
      referenceEl: _this.refs.imageMenuToggle,
      isVideoMenu: type === 'video',
      fromNodeMenu: true,
      positionToLeft: false
    });
  }
};

this.handleRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodeTag: _this
    });
  }
};

this.handleImageRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodeTag: _this,
      isImageMenu: true
    });
  }
};

this.handleVideoRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodeTag: _this,
      isVideoMenu: true
    });
  }
};

this.handleFileRightClick = function (e) {
  if (e.shiftKey) {
    // make shift click change selection state
    return _this.screenClick(e);
  }
  if (e.which && e.which === 1) {
    if (_this.instance.attachedFile.file_type === 'application/pdf') {
      e.preventDefault();
      e.stopPropagation();
      _this.canvas.tags.gallery.summon({ node: _this.instance });
      return false;
    }
  }
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      isFileMenu: true,
      nodeTag: _this,
      isPdfFile: _this.instance.attachedFile.file_type === 'application/pdf'
    });
  }
};

this.showImage = function () {
  return _this.instance.attachedFile && _constants.ALLOWED_IMAGE_FILE_TYPES.includes(_this.instance.attachedFile.file_type);
};

this.showFile = function () {
  if (_this.instance.attachedFile) {
    return !_this.showImage() && !_this.showVideo();
  } else {
    return false;
  }
};

this.showVideo = function () {
  if (_this.instance.attachedFile) {
    return (0, _util.canPlayVideo)(_this.instance.attachedFile.file_type);
  } else {
    return false;
  }
};

this.getFileName = function () {
  if (_this.instance.attachedFile) {
    var name = _this.instance.attachedFile.name;
    if (name && name.includes('.')) {
      return name.split('.').slice(0, -1).join('.');
    } else {
      return name;
    }
  }
  return '';
};

this.getIconName = function () {
  if (_this.instance.attachedFile) {
    return (0, _util.getIconNameFromExtension)(_this.getFileExtension());
  }
};

this.getFileExtension = function () {
  if (_this.instance.attachedFile) {
    var name = _this.instance.attachedFile.name;
    if (name && name.includes('.')) {
      return '.' + name.split('.')[name.split('.').length - 1];
    } else {
      return '';
    }
  }
  return '';
};

this.getFileUrl = function () {
  if (_this.instance.attachedFile) {
    return decodeURIComponent(_this.instance.attachedFile.file_url);
  }
};

this.handleFileClick = function (e) {
  if (e.shiftKey) {
    // make shift click change selection state
    return _this.screenClick(e);
  }

  if (_this.instance.attachedFile) {
    e.preventDefault();
    _this.canvas.tags.gallery.summon({ node: _this.instance });
  }
};

this.handleVideoClick = function (e) {
  if (e.shiftKey) {
    // make shift click change selection state
    return _this.screenClick(e);
  }
};

this.getFileIconColor = _util.getFileIconColor.bind(this);

this.getFileExtension = function () {
  if (_this.instance.attachedFile) {
    var name = _this.instance.attachedFile.name;
    if (name && name.includes('.')) {
      return '.' + name.split('.')[name.split('.').length - 1];
    } else {
      return '';
    }
  }

  e.stopPropagation();
  e.stopImmediatePropagation();
  _this.canvas.tags.gallery.summon({ node: _this.instance });
};

this.shuttleCursorToTitle = function (user) {
  _collaboratorsUi.cui.shuttleCursorToField(user, _this.refs.titleWrapper);
};

this.shuttleCursorToSummary = function (user) {
  _collaboratorsUi.cui.shuttleCursorToField(user, _this.refs.summaryWrapper);
};

this.hasComments = function () {
  if (_commentsUi.commentsUI.startingNewCommentOnNode(_this.id)) return true;
  var comments = _this.canvas.store.nodeTopComments(_this.id);
  return comments.length ? true : false;
};

this.handleImageMouseEnter = function (e) {
  _this.canvas.setHoveredImageNode(_this);
};

this.handleImageMouseLeave = function (e) {
  _this.canvas.clearHoveredImageNode();
};

this.isShownCommentContainer = function () {
  return _commentsUi.commentsUI.isShownCommentContainer(_this.id);
};

this.getTotalCommentCount = function () {
  var count = _commentsUi.commentsUI.getTotalCommentCountOnNode(_this.id);
  if (count > 99) {
    return '99';
  }
  return count;
};

this.toggleComments = function () {
  var id = _this.id;

  if (_commentsUi.commentsUI.isShownCommentContainer(id)) {
    _commentsUi.commentsUI.hideCommentContainer(id);
    _eventTracking2.default.track({
      category: 'Comment-Action',
      action: 'Toggle-Node-Comment',
      label: 'Hide-Node-Comment'
    });
  } else {
    _commentsUi.commentsUI.showCommentContainer(id);
    _eventTracking2.default.track({
      category: 'Comment-Action',
      action: 'Toggle-Node-Comment',
      label: 'Show-Node-Comment'
    });
  }
};

this.enablePerspectiveTags = function () {
  _this.enablePerspectiveEyeballTags = _this.getPointPerspective();
  _this.enablePerspectiveDotTags = _perspectivesUi.pui.getNodePerspectives(_this.instance).length;
};

this.enablePerspectiveTags();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node.html
// module id = 609
// module chunks = 0